var _defs, _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeam({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 509 609",
    width: 509,
    height: 609,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "P",
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g1",
    cx: 480.6,
    cy: 244,
    r: 27.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#fff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#25054d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g2",
    cx: 480.6,
    cy: 266.4,
    r: 20.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#fff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#25054d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g3",
    cx: 480.6,
    cy: 284.3,
    r: 15.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#fff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#25054d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g4",
    x1: 507.6,
    y1: 60.9,
    x2: 397.6,
    y2: 251.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5513ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#be3bff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g5",
    cx: 402,
    cy: 186.7,
    r: 48.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g6",
    x1: 400.1,
    y1: 138.4,
    x2: 771.7,
    y2: 109.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5513ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#be3bff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g7",
    x1: 299.8,
    y1: 86.3,
    x2: 491.4,
    y2: 118.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5513ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#be3bff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g8",
    x1: 431,
    y1: 136.5,
    x2: 321,
    y2: 327.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5513ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#be3bff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g9",
    cx: 325.4,
    cy: 262.3,
    r: 48.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g10",
    x1: 326,
    y1: 221.7,
    x2: 687,
    y2: 194.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5513ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#be3bff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g11",
    x1: 222.9,
    y1: 179.2,
    x2: 405,
    y2: 209.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5513ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#be3bff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g12",
    x1: 355.1,
    y1: 213,
    x2: 245,
    y2: 403.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5513ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#be3bff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g13",
    cx: 249.5,
    cy: 338.8,
    r: 48.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g14",
    x1: 252.5,
    y1: 305,
    x2: 602.6,
    y2: 278.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5513ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#be3bff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g15",
    x1: 146.9,
    y1: 270.8,
    x2: 319.3,
    y2: 299.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5513ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#be3bff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g16",
    x1: 278.5,
    y1: 288.6,
    x2: 168.5,
    y2: 479.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5513ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#be3bff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g17",
    cx: 172.9,
    cy: 414.4,
    r: 48.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g18",
    x1: 178.2,
    y1: 386.1,
    x2: 517.8,
    y2: 360.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5513ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#be3bff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g19",
    x1: 70.7,
    y1: 358.8,
    x2: 233.6,
    y2: 386.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5513ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#be3bff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g20",
    x1: 200.7,
    y1: 364.3,
    x2: 90.7,
    y2: 554.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5513ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#be3bff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g21",
    cx: 95.1,
    cy: 490,
    r: 48.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g22",
    x1: 102.6,
    y1: 466,
    x2: 431.8,
    y2: 440.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5513ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#be3bff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g23",
    x1: -6.3,
    y1: 444.3,
    x2: 147.3,
    y2: 470,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5513ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#be3bff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g24",
    x1: 78.3,
    y1: 450.5,
    x2: 127.9,
    y2: 438.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#d4d1d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g25",
    x1: 171.5,
    y1: 406.7,
    x2: 172.1,
    y2: 438.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#d4d1d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g26",
    cx: 133.1,
    cy: 288.5,
    r: 92.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#fedfcb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#f9b69e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#f2a78c"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g27",
    cx: 92.6,
    cy: 357.1,
    r: 8.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#fedfcb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#f9b69e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#f2a78c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g28",
    x1: 126.2,
    y1: 369.1,
    x2: 120.3,
    y2: 282.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#c6ccd1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g29",
    x1: 92.9,
    y1: 348.7,
    x2: 65,
    y2: 314.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g30",
    cx: 159.1,
    cy: 374.9,
    r: 43.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#fedfcb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#f9b69e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#f2a78c"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g31",
    cx: 170.8,
    cy: 398.4,
    r: 39.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#fedfcb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#f9b69e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#f2a78c"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g32",
    cx: 137.8,
    cy: 439.5,
    r: 66.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#fedfcb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#f9b69e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#f2a78c"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g33",
    cx: 230.3,
    cy: 415,
    r: 138.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#fedfcb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#f9b69e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#f2a78c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g34",
    x1: 133.5,
    y1: 411.6,
    x2: 152.9,
    y2: 411.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#25054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#45108a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g35",
    x1: 85.3,
    y1: 454.7,
    x2: 99.5,
    y2: 454.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#25054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#45108a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g36",
    x1: 90.4,
    y1: 461.2,
    x2: 115.2,
    y2: 449.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#25054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#45108a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g37",
    x1: 101.3,
    y1: 324,
    x2: 147.4,
    y2: 324,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff63ce"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g38",
    x1: 121.7,
    y1: 344.6,
    x2: 140.3,
    y2: 327.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff63ce"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g39",
    x1: 138.5,
    y1: 417.8,
    x2: 123.7,
    y2: 396.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#25054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#45108a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g40",
    x1: 111.7,
    y1: 373.5,
    x2: 120.9,
    y2: 351.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff63ce"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g41",
    x1: 120.3,
    y1: 318.9,
    x2: 172.1,
    y2: 322.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff63ce"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g42",
    x1: 114.7,
    y1: 299.6,
    x2: 147.8,
    y2: 299.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#602213"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7a4108"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g43",
    cx: 194,
    cy: 286.6,
    r: 7.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#fedfcb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#f9b69e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#f2a78c"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g44",
    cx: 190.2,
    cy: 286.1,
    r: 6.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#fedfcb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#f9b69e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#f2a78c"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g45",
    cx: 200.3,
    cy: 287.2,
    r: 12.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#fedfcb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#f9b69e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#f2a78c"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g46",
    cx: 192.3,
    cy: 286,
    r: 7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#fedfcb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#f9b69e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#f2a78c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g47",
    x1: 276.8,
    y1: 342.4,
    x2: 254.6,
    y2: 325.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#25054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#45108a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g48",
    x1: 235.6,
    y1: 318.5,
    x2: 214.4,
    y2: 318.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#25054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#45108a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g49",
    x1: 208.3,
    y1: 231.1,
    x2: 271.1,
    y2: 231.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9d9eb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d4d1d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eeebf2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g50",
    cx: 166.4,
    cy: 270.9,
    r: 24.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#fedfcb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#f9b69e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#f2a78c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g51",
    x1: 217.5,
    y1: 301.2,
    x2: 124.8,
    y2: 183.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#138bbd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g52",
    cx: 235.3,
    cy: 209.1,
    r: 21.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#fedfcb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#f9b69e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#f2a78c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g53",
    x1: 210.6,
    y1: 203.1,
    x2: 223.4,
    y2: 208.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9d9eb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d4d1d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g54",
    cx: 248.9,
    cy: 262.8,
    r: 19.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#fedfcb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#f9b69e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#f2a78c"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g55",
    cx: 204.8,
    cy: 207.7,
    r: 16.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#fedfcb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#f9b69e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#f2a78c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g56",
    x1: 228.7,
    y1: 211.1,
    x2: 196.2,
    y2: 207.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#602213"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7a4108"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g57",
    x1: 290.3,
    y1: 260,
    x2: 260,
    y2: 281.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9d9eb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d4d1d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g58",
    x1: 324.9,
    y1: 237.6,
    x2: 185.4,
    y2: 318.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#138bbd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g59",
    cx: 188.9,
    cy: 278.7,
    r: 6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#fedfcb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#f9b69e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#f2a78c"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g60",
    cx: 177.1,
    cy: 274.6,
    r: 3.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#fedfcb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#f9b69e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#f2a78c"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g61",
    cx: 177.1,
    cy: 274.6,
    r: 3.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#fedfcb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#f9b69e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#f2a78c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g62",
    x1: 419.8,
    y1: 152.8,
    x2: 408.9,
    y2: 168.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#25054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#45108a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g63",
    x1: 435.4,
    y1: 159.2,
    x2: 419.5,
    y2: 160.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#25054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#45108a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g64",
    x1: 373.6,
    y1: 163.4,
    x2: 322.2,
    y2: 96.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#6b24d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a56ef4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g65",
    cx: 432.1,
    cy: 8.5,
    r: 29.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#fedfcb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#f9b69e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#f2a78c"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g66",
    cx: 332.9,
    cy: 8.8,
    r: 48.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#fedfcb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#f9b69e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#f2a78c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g67",
    x1: 301,
    y1: 92,
    x2: 346.9,
    y2: -11.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9d9eb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d4d1d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eeebf2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g68",
    cx: 368.7,
    cy: -11.7,
    r: 14.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#fedfcb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#f9b69e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#f2a78c"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g69",
    cx: 427,
    cy: 4.3,
    r: 7.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#fedfcb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#f9b69e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#f2a78c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g70",
    x1: 372.9,
    y1: 83.6,
    x2: 376.7,
    y2: 59.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9d9eb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d4d1d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eeebf2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g71",
    cx: 377.5,
    cy: 16.2,
    r: 27.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#fedfcb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#f9b69e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#f2a78c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g72",
    x1: 382.9,
    y1: 20.2,
    x2: 397.5,
    y2: 20.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#602213"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7a4108"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g73",
    cx: 375.1,
    cy: -10.9,
    r: 47.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#fedfcb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#f9b69e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#f2a78c"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g74",
    cx: 64.5,
    cy: 437.9,
    r: 29.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#fff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#25054d",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g75",
    x1: 202.8,
    y1: 234.2,
    x2: 763.8,
    y2: -57.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#55507a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#9d9eb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d4d1d8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g76",
    x1: 114.2,
    y1: 277.3,
    x2: 679.7,
    y2: 99.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#55507a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#9d9eb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d4d1d8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g77",
    x1: 362.9,
    y1: 260.9,
    x2: 380,
    y2: 276.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#55507a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#9d9eb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d4d1d8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g78",
    x1: 373.1,
    y1: 355.1,
    x2: 358,
    y2: 352.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#55507a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#9d9eb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d4d1d8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g79",
    x1: 492.5,
    y1: 361.5,
    x2: 251.2,
    y2: 308.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#55507a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#9d9eb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d4d1d8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g80",
    x1: 309.8,
    y1: 290,
    x2: 383.2,
    y2: 357.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#55507a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#9d9eb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d4d1d8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g81",
    x1: 380.1,
    y1: 373.4,
    x2: 365.1,
    y2: 370.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#55507a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#9d9eb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d4d1d8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g82",
    x1: 499.5,
    y1: 379.8,
    x2: 258.3,
    y2: 326.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#55507a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#9d9eb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d4d1d8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g83",
    x1: 316.8,
    y1: 308.3,
    x2: 390.3,
    y2: 376.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#55507a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#9d9eb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d4d1d8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g84",
    x1: 387.2,
    y1: 391.8,
    x2: 372.2,
    y2: 389,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#55507a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#9d9eb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d4d1d8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g85",
    x1: 506.6,
    y1: 398.2,
    x2: 265.4,
    y2: 345.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#55507a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#9d9eb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d4d1d8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g86",
    x1: 323.9,
    y1: 326.7,
    x2: 397.4,
    y2: 394.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#55507a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#9d9eb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d4d1d8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g87",
    x1: 394.3,
    y1: 410.2,
    x2: 379.3,
    y2: 407.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#55507a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#9d9eb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d4d1d8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g88",
    x1: 513.7,
    y1: 416.5,
    x2: 272.5,
    y2: 363.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#55507a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#9d9eb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d4d1d8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g89",
    x1: 331,
    y1: 345.1,
    x2: 404.4,
    y2: 412.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#55507a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#9d9eb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d4d1d8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g90",
    x1: 351.4,
    y1: 300,
    x2: 336.4,
    y2: 297.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#55507a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#9d9eb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d4d1d8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g91",
    x1: 470.8,
    y1: 306.4,
    x2: 229.5,
    y2: 253.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#55507a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#9d9eb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d4d1d8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g92",
    x1: 288.1,
    y1: 235,
    x2: 361.5,
    y2: 302.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#55507a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#9d9eb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d4d1d8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g93",
    x1: 358.5,
    y1: 318.4,
    x2: 343.4,
    y2: 315.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#55507a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#9d9eb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d4d1d8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g94",
    x1: 477.9,
    y1: 324.7,
    x2: 236.6,
    y2: 271.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#55507a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#9d9eb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d4d1d8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g95",
    x1: 295.2,
    y1: 253.3,
    x2: 368.6,
    y2: 321,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#55507a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#9d9eb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d4d1d8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g96",
    x1: 365.6,
    y1: 336.8,
    x2: 350.5,
    y2: 333.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#55507a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#9d9eb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d4d1d8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g97",
    x1: 485,
    y1: 343.2,
    x2: 243.7,
    y2: 290.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#55507a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#9d9eb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d4d1d8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g98",
    x1: 302.3,
    y1: 271.7,
    x2: 375.7,
    y2: 339.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#55507a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#9d9eb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d4d1d8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g99",
    x1: 401.4,
    y1: 428.4,
    x2: 386.3,
    y2: 425.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#55507a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#9d9eb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d4d1d8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g100",
    x1: 520.8,
    y1: 434.8,
    x2: 279.5,
    y2: 381.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#55507a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#9d9eb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d4d1d8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g101",
    x1: 338.1,
    y1: 363.3,
    x2: 411.5,
    y2: 431.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#55507a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#9d9eb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d4d1d8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g102",
    x1: 408.4,
    y1: 446.8,
    x2: 393.4,
    y2: 443.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#55507a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#9d9eb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d4d1d8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g103",
    x1: 341.1,
    y1: 456,
    x2: 533.2,
    y2: 395.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#55507a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#9d9eb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d4d1d8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g104",
    x1: 345.1,
    y1: 381.7,
    x2: 418.6,
    y2: 449.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#55507a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#9d9eb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d4d1d8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g105",
    x1: 1008.6,
    y1: -1210.4,
    x2: 499.8,
    y2: -1389.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#55507a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#9d9eb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d4d1d8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g106",
    x1: 77.4,
    y1: 297.9,
    x2: 642.9,
    y2: 119.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#55507a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#9d9eb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d4d1d8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g107",
    x1: 326.1,
    y1: 281.5,
    x2: 343.2,
    y2: 297.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#55507a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#9d9eb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d4d1d8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g108",
    x1: 150.4,
    y1: 463.1,
    x2: -189,
    y2: 286.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#55507a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#9d9eb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d4d1d8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g109",
    x1: 202.6,
    y1: 487.5,
    x2: -137.9,
    y2: 380.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#55507a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#9d9eb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d4d1d8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g110",
    x1: 60.9,
    y1: 471.4,
    x2: 43.8,
    y2: 487.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#55507a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#9d9eb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d4d1d8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g111",
    x1: 71.2,
    y1: 515.2,
    x2: 86.3,
    y2: 512.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#55507a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#9d9eb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d4d1d8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g112",
    x1: -48.2,
    y1: 521.6,
    x2: 193.1,
    y2: 468.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#55507a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#9d9eb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d4d1d8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g113",
    x1: 134.5,
    y1: 450.1,
    x2: 61.1,
    y2: 517.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#55507a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#9d9eb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d4d1d8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g114",
    x1: 64.1,
    y1: 533.6,
    x2: 79.2,
    y2: 530.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#55507a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#9d9eb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d4d1d8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g115",
    x1: -55.3,
    y1: 540,
    x2: 186,
    y2: 487,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#55507a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#9d9eb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d4d1d8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g116",
    x1: 127.4,
    y1: 468.5,
    x2: 54,
    y2: 536.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#55507a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#9d9eb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d4d1d8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g117",
    x1: 57.1,
    y1: 552,
    x2: 72.1,
    y2: 549.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#55507a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#9d9eb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d4d1d8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g118",
    x1: -62.3,
    y1: 558.3,
    x2: 178.9,
    y2: 505.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#55507a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#9d9eb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d4d1d8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g119",
    x1: 120.4,
    y1: 486.9,
    x2: 46.9,
    y2: 554.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#55507a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#9d9eb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d4d1d8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g120",
    x1: 50,
    y1: 570.2,
    x2: 65,
    y2: 567.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#55507a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#9d9eb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d4d1d8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g121",
    x1: -69.4,
    y1: 576.6,
    x2: 171.9,
    y2: 523.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#55507a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#9d9eb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d4d1d8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g122",
    x1: 113.3,
    y1: 505.1,
    x2: 39.9,
    y2: 572.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#55507a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#9d9eb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d4d1d8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g123",
    x1: 42.9,
    y1: 588.5,
    x2: 58,
    y2: 585.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#55507a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#9d9eb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d4d1d8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g124",
    x1: 110.2,
    y1: 597.8,
    x2: -81.8,
    y2: 537.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#55507a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#9d9eb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d4d1d8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g125",
    x1: 106.2,
    y1: 523.5,
    x2: 32.8,
    y2: 591.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#55507a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#9d9eb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d4d1d8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g126",
    x1: -168.7,
    y1: 46,
    x2: 147,
    y2: -65.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#55507a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#9d9eb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d4d1d8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g127",
    x1: 239.4,
    y1: 508,
    x2: -101.1,
    y2: 400.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#55507a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#9d9eb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d4d1d8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g128",
    x1: 97.7,
    y1: 492,
    x2: 80.6,
    y2: 507.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#55507a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#9d9eb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d4d1d8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g129",
    cx: 383.9,
    cy: 307.2,
    r: 7.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#bcbec0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g130",
    cx: 385.1,
    cy: 347.1,
    r: 16,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#fedfcb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f9b69e"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g131",
    cx: 378.1,
    cy: 348.2,
    r: 0.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#fedfcb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f9b69e"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g132",
    cx: 380.2,
    cy: 348.4,
    r: 0.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#fedfcb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f9b69e"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g133",
    cx: 387.9,
    cy: 344,
    r: 3.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#fedfcb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f9b69e"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g134",
    cx: 376.3,
    cy: 350.7,
    r: 0,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#fedfcb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f9b69e"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g135",
    cx: 380.9,
    cy: 346.9,
    r: 0.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#fedfcb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f9b69e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g136",
    x1: 395.6,
    y1: 308.2,
    x2: 406.8,
    y2: 310,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#138bbd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g137",
    cx: 404.7,
    cy: 304.4,
    r: 37.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#fedfcb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#f9b69e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#f2a78c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g138",
    x1: 390.6,
    y1: 320.1,
    x2: 385.5,
    y2: 314.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9d9eb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d4d1d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eeebf2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g139",
    x1: 371.8,
    y1: 343.9,
    x2: 404.7,
    y2: 302.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#138bbd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g140",
    x1: 408,
    y1: 433.4,
    x2: 410.4,
    y2: 403.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#25054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#45108a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g141",
    x1: 427.7,
    y1: 373.2,
    x2: 398.8,
    y2: 370.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#138bbd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g142",
    x1: 434.6,
    y1: 437.3,
    x2: 432.4,
    y2: 426.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#25054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#45108a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g143",
    x1: 416,
    y1: 373.6,
    x2: 434.9,
    y2: 369.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#138bbd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g144",
    cx: 399.2,
    cy: 313.4,
    r: 14.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#fedfcb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f9b69e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g145",
    x1: 402.7,
    y1: 330.9,
    x2: 386.4,
    y2: 311.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#602213"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7a4108"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g146",
    x1: 413.8,
    y1: 339.7,
    x2: 400.6,
    y2: 324.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9d9eb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d4d1d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eeebf2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g147",
    x1: 390.7,
    y1: 325.3,
    x2: 426.7,
    y2: 318.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#138bbd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g148",
    x1: 397.6,
    y1: 343.6,
    x2: 402.4,
    y2: 317.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#138bbd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g149",
    cx: 408.1,
    cy: 329.5,
    r: 9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g150",
    x1: 430.7,
    y1: 361.2,
    x2: 399.1,
    y2: 311.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#138bbd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".a{opacity:.6;mix-blend-mode:color-dodge;fill:#7c1dc9}.b{opacity:.8;mix-blend-mode:color-dodge;fill:#7c1dc9}.c{opacity:.3;mix-blend-mode:color-dodge;fill:#7c1dc9}.d{opacity:.1;mix-blend-mode:color-dodge;fill:#7c1dc9}.e{opacity:.5;mix-blend-mode:color-dodge;fill:#7c1dc9}.f{mix-blend-mode:color-dodge;fill:#7c1dc9}.g{opacity:.4;mix-blend-mode:color-dodge;fill:#7c1dc9}.h{mix-blend-mode:color-dodge;fill:url(#g1)}.i{mix-blend-mode:color-dodge;fill:url(#g2)}.j{mix-blend-mode:color-dodge;fill:url(#g3)}.k{fill:url(#g4)}.l{mix-blend-mode:color-dodge;fill:url(#g5)}.m{fill:url(#g6)}.n{fill:url(#g7)}.o{fill:url(#g8)}.p{mix-blend-mode:color-dodge;fill:url(#g9)}.q{fill:url(#g10)}.r{fill:url(#g11)}.s{fill:url(#g12)}.t{mix-blend-mode:color-dodge;fill:url(#g13)}.u{fill:url(#g14)}.v{fill:url(#g15)}.w{fill:url(#g16)}.x{mix-blend-mode:color-dodge;fill:url(#g17)}.y{fill:url(#g18)}.z{fill:url(#g19)}.A{fill:url(#g20)}.B{mix-blend-mode:color-dodge;fill:url(#g21)}.C{fill:url(#g22)}.D{fill:url(#g23)}.E{mix-blend-mode:multiply;fill:url(#g24)}.F{mix-blend-mode:multiply;fill:url(#g25)}.G{fill:url(#g26)}.H{fill:url(#g27)}.I{fill:url(#g28)}.J{mix-blend-mode:multiply;fill:url(#g29)}.K{fill:url(#g30)}.L{fill:url(#g31)}.M{fill:url(#g32)}.N{fill:url(#g33)}.O{fill:url(#g34)}.P{fill:url(#g35)}.Q{fill:url(#g36)}.R{fill:url(#g37)}.S{fill:url(#g38)}.T{fill:url(#g39)}.U{fill:url(#g40)}.V{fill:url(#g41)}.W{fill:url(#g42)}.X{fill:url(#g43)}.Y{fill:url(#g44)}.Z{fill:url(#g45)}.a0{fill:url(#g46)}.a1{mix-blend-mode:multiply;fill:#d1d3d4}.a2{opacity:.1;mix-blend-mode:multiply}.a3{fill:#10054d}.a4{fill:url(#g47)}.a5{fill:url(#g48)}.a6{fill:url(#g49)}.a7{fill:url(#g50)}.a8{fill:url(#g51)}.a9{fill:url(#g52)}.aa{mix-blend-mode:multiply;fill:url(#g53)}.ab{fill:url(#g54)}.ac{fill:url(#g55)}.ad{fill:url(#g56)}.ae{mix-blend-mode:multiply;fill:url(#g57)}.af{fill:url(#g58)}.ag{fill:url(#g59)}.ah{fill:url(#g60)}.ai{fill:url(#g61)}.aj{fill:url(#g62)}.ak{fill:url(#g63)}.al{fill:url(#g64)}.am{fill:url(#g65)}.an{fill:url(#g66)}.ao{fill:url(#g67)}.ap{fill:url(#g68)}.aq{fill:url(#g69)}.ar{fill:url(#g70)}.as{fill:url(#g71)}.at{fill:url(#g72)}.au{fill:url(#g73)}.av{fill:#c211a1}.aw{mix-blend-mode:color-dodge;fill:url(#g74)}.ax{opacity:0}.ay{opacity:.1}.az{opacity:.2}.aA{fill:url(#g75)}.aB{fill:url(#g76)}.aC{fill:url(#g77)}.aD{fill:url(#g78)}.aE{fill:url(#g79)}.aF{fill:url(#g80)}.aG{fill:url(#g81)}.aH{fill:url(#g82)}.aI{fill:url(#g83)}.aJ{fill:url(#g84)}.aK{fill:url(#g85)}.aL{fill:url(#g86)}.aM{fill:url(#g87)}.aN{fill:url(#g88)}.aO{fill:url(#g89)}.aP{fill:url(#g90)}.aQ{fill:url(#g91)}.aR{fill:url(#g92)}.aS{fill:url(#g93)}.aT{fill:url(#g94)}.aU{fill:url(#g95)}.aV{fill:url(#g96)}.aW{fill:url(#g97)}.aX{fill:url(#g98)}.aY{fill:url(#g99)}.aZ{fill:url(#g100)}.b0{fill:url(#g101)}.b1{fill:url(#g102)}.b2{fill:url(#g103)}.b3{fill:url(#g104)}.b4{fill:url(#g105)}.b5{fill:url(#g106)}.b6{fill:url(#g107)}.b7{fill:url(#g108)}.b8{fill:url(#g109)}.b9{fill:url(#g110)}.ba{fill:url(#g111)}.bb{fill:url(#g112)}.bc{fill:url(#g113)}.bd{fill:url(#g114)}.be{fill:url(#g115)}.bf{fill:url(#g116)}.bg{fill:url(#g117)}.bh{fill:url(#g118)}.bi{fill:url(#g119)}.bj{fill:url(#g120)}.bk{fill:url(#g121)}.bl{fill:url(#g122)}.bm{fill:url(#g123)}.bn{fill:url(#g124)}.bo{fill:url(#g125)}.bp{fill:url(#g126)}.bq{fill:url(#g127)}.br{fill:url(#g128)}.bs{mix-blend-mode:multiply;fill:url(#g129)}.bt{fill:url(#g130)}.bu{fill:url(#g131)}.bv{fill:url(#g132)}.bw{fill:url(#g133)}.bx{fill:url(#g134)}.by{fill:url(#g135)}.bz{fill:url(#g136)}.bA{fill:url(#g137)}.bB{fill:url(#g138)}.bC{fill:url(#g139)}.bD{fill:url(#g140)}.bE{fill:url(#g141)}.bF{fill:url(#g142)}.bG{fill:url(#g143)}.bH{fill:url(#g144)}.bI{fill:url(#g145)}.bJ{fill:url(#g146)}.bK{fill:url(#g147)}.bL{fill:url(#g148)}.bM{mix-blend-mode:color-dodge;fill:url(#g149)}.bN{fill:url(#g150)}")), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      mixBlendMode: "color-dodge"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m238.2 532l12.7 7.4 6.1-3.6-12.7-7.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m247.6 526.6l12.7 7.3 6.9-3.9-12.7-7.4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m219.2 543l12.7 7.3 4.8-2.7-12.7-7.4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m212.7 546.7l12.7 7.4 2.5-1.2-12.7-7.4z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m228.7 537.5l12.7 7.3 5.4-3.1-12.7-7.4z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m246.6 514.3l34.6 19.9 6.5-23.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      mixBlendMode: "color-dodge"
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m365.2 521l12.7 7.4 6.1-3.6-12.7-7.3z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m374.7 515.6l12.7 7.3 6.8-3.9-12.7-7.4z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m346.2 532l12.7 7.3 4.8-2.7-12.7-7.4z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m339.8 535.8l12.7 7.3 2.5-1.2-12.8-7.4z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m355.7 526.5l12.7 7.4 5.5-3.2-12.7-7.3z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m373.7 503.3l34.5 19.9 6.5-23.6z"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m275.8 75.4v23.3l12.6-18.9z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m258.7 85.2v23.2l12.6-18.9z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m241.6 95v23.2l12.6-18.9z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m224.5 104.7v23.3l12.6-18.9z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m207.4 114.5v23.3l12.5-18.9z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m147.2 204v23.3l12.6-18.9z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m130.1 213.8v23.3l12.6-18.9z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m113 223.6v23.3l12.5-18.9z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m95.9 233.4v23.2l12.5-18.9z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m78.8 243.2v23.2l12.5-18.9z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "m497.3 222.2c-12.1-9.2-29.3-6.9-38.5 5.2-9.2 12.1-6.9 29.3 5.2 38.5 12 9.2 29.3 6.9 38.5-5.2 9.2-12.1 6.8-29.3-5.2-38.5z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "m493.2 249.8c-9.1-6.9-22.2-5.2-29.1 4-7 9.1-5.2 22.1 3.9 29.1 9.1 7 22.2 5.2 29.2-3.9 6.9-9.2 5.2-22.2-4-29.2z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "m490.1 271.9c-6.9-5.3-16.7-3.9-21.9 2.9-5.2 6.9-3.9 16.7 3 21.9 6.8 5.2 16.6 3.9 21.8-3 5.3-6.8 3.9-16.6-2.9-21.8z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.9
    }
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m402 129.6l65.8 38.1-65.8 38-65.9-38.1z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "m402.3 203.1l65.5-35.4-65.8 38-65.9-38.1z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "m467.9 363.8l-65.9 38.1v-196.2l65.9-38.1z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "m402 401.9l-65.9-38.1v-196.2l65.9 38.1z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.9
    }
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "m325.4 205.2l65.9 38.1-65.9 38-65.8-38z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "m325.7 278.7l65.6-35.4-65.9 38-65.8-38z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "m391.3 408.4l-65.9 38v-165.1l65.9-38z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "m325.4 446.4l-65.8-38v-165.1l65.8 38z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.9
    }
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "m249.5 281.7l65.8 38.1-65.8 38-65.9-38.1z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "m249.8 355.2l65.5-35.4-65.8 38-65.9-38.1z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "m315.4 452.9l-65.9 38v-133.1l65.9-38.1z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "m249.5 490.9l-65.9-38v-133.2l65.9 38.1z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.9
    }
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "m172.9 357.4l65.8 38-65.8 38-65.8-38z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "m173.2 430.8l65.5-35.4-65.8 38-65.8-38z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "m238.8 497.4l-65.9 38.1v-102.1l65.9-38z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "m172.9 535.5l-65.9-38.1v-102l65.9 38z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.9
    }
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "A",
    d: "m95.1 433l65.9 38-65.9 38.1-65.8-38.1z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "B",
    d: "m95.4 506.5l65.6-35.5-65.9 38.1-65.8-38.1z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "C",
    d: "m161 542.6l-65.9 38v-71.6l65.9-38z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "D",
    d: "m95.1 580.6l-65.8-38v-71.6l65.8 38z"
  }))), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "E",
    d: "m84.8 472.3c7.4 5.2 19.3-2.8 25.6-6.3 6.3-3.4 22.3-10.8 22.3-10.8l-14.2-9.9c0 0-45.1 19.1-33.7 27z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "F",
    d: "m147.8 412.9c13.4 0.9-2.4 6.7-3.3 15.7-0.8 8.9-0.6 16.3-6.7 16.3-6.1 0-3.4-21.5 0.1-29 2.6-5.4 7.3-3.1 9.9-3z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "G",
    d: "m126.4 324.3c0 0-4-2.8-8.2 0.4-4.2 3.3-9.9 14.1-12.8 16.8-2.9 2.8-4 5.3-5.7 10.5-1.7 5.3-4.3 15.6-5.7 17-1.3 1.5-3.5 3.9-4.1 5.1-0.7 1.1-1.6 4.9-1.3 5.7 0.5 1.3 1-0.5 1.3-1.4 0.1-0.7 0.8-3.2 0.9-2.9 0.1 0.3-0.5 1.8-0.8 2.8-0.7 2.2-0.5 4.3 0.1 4.9 0.5 0.6 0.7-2 1.3-4.1 0.6-2.2 1-2.6 1.2-2.6 0.1 0-0.8 2.6-1.2 4-0.2 0.8-0.3 1.7-0.3 3 0 1 0.8 2.1 1.2 0.3 0.4-2.2 0.4-2.2 0.6-3.1 0.3-0.9 1.2-3.4 1.5-3.2 0.3 0.1-0.4 1.8-0.7 3-0.4 1.2-0.6 2-0.7 3.4-0.1 1.2 0.8 2.4 1.2 0.5 0.3-2.1 0.7-2.8 1-3.8 0.3-1.1 1.2-2.5 1.8-2.6 0.7-0.1 0.3 0.5 0.2 1.7 0 1.2 1 2.7 1.5 2.7 0.5-0.1 0.3-1.3 0.2-2.4-0.1-1.1 0.9-2.9 0.7-4.6-0.1-1.6-0.5-2.7-0.5-3.3 0.1-0.6 1.7-5.5 4.2-11.1 2.5-5.7 4.5-11.5 4.6-12.1 0.1-0.6 10-9.8 10-9.8l23.5 5.9c0 0 4.3-7.5 8.3-9.4 3.6-1.6 13-3 15-3.6 2.1-0.5 7.1-1.4 8.5-3.9 1.4-2.4 9.4-21.8 10-23.1 0.5-1.2 4.7-5.8 5.1-6.7 1.1-2.2 0.6-4.8 0.3-6.1-0.4-1.8-1.9-3.5-3.4-3.7-1.6-0.2-2.5 3.4-3.1 4.9-0.7 1.5-2.5 2.8-2.5 1.5 0-1.4-0.1-3.5-0.6-4-0.5-0.4-1.1 0.6-1.1 1.8 0 1.3-0.5 4.8-0.1 6.4 0.4 1.6 0.8 3.4 0.4 4.5-0.5 1-4.4 7.6-6.2 11.3-1.9 3.7-4.6 8.5-4.9 8.9-0.4 0.5-6.6 1.6-9.7 1.8-3 0.3-11.9 1-15.1 1.8-2.5 0.6-4.1 1.3-3.5-0.9 0.5-2.3 2.1-4.2 3.6-4.4 1.5-0.2 2.3-1.3 3.1-3.6 0.7-2.3 1.9-9.8 0.8-12.9-1-3.1-7.8-7.9-13.9-3.8-6.2 4-6.1 9.7-4.6 13.2 1.5 3.4 2.5 7.7 1.8 9-0.8 1.4-1.2 1-3.2 0.3z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "H",
    d: "m130.5 338l-9.5-5.9c0 0-11.7 12.2-13.2 13.7-1.5 1.4-3 7.7-3.6 8.6-0.6 0.8-3.1 8.3-3.9 10.9-0.9 2.6-1.2 6.8-1.2 6.8 0.1-0.6 1.7-5.5 4.2-11.1 2.5-5.7 4.5-11.5 4.6-12.1 0.1-0.6 10-9.8 10-9.8l11.8 3z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "I",
    d: "m170.6 316.6c-1.7 3.3-3.6 6.6-3.8 6.9-0.6 0.4-6.3 1.4-9.4 1.7h-0.3c-3.2 0.3-11.7 0.9-15 1.7q-0.5 0.2-1 0.3c-0.7 0.2-1.3 0.3-1.7 0.3q-0.2 0-0.2 0c-0.1 0-0.2-0.2 0-0.9q0.1-0.4 0.2-0.8l-10.1-3.4c0.1 0.6 0 1.1-0.1 1.4-0.4 0.7-0.6 0.7-0.7 0.7-0.3 0-0.7-0.2-1.4-0.4l-0.4-0.2c-0.1-0.1-1.8-1.2-4.1-1.2q-2.5 0-4.7 1.7c-2.5 1.9-5.5 6.4-8.2 10.4-1.8 2.7-3.5 5.3-4.6 6.4-3 2.9-4.2 5.5-5.9 10.7-0.5 1.6-1.1 3.6-1.7 5.7l6.6 2.7c2.3-5.4 4.2-10.7 4.3-11.3 0.3-0.6 6-6 9.6-9.4l23.6 6 0.2-0.3c0-0.1 4.3-7.5 8.1-9.3 2.4-1.1 7.8-2.1 11.4-2.8 1.6-0.3 2.9-0.5 3.6-0.7q0.4-0.1 1-0.3c2.5-0.6 6.4-1.6 7.7-3.8 0.6-1 2.1-4.6 3.9-8.6z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "J",
    d: "m130.5 338l-9.5-5.9c0 0-11.7 12.2-13.2 13.7-1.5 1.4-4 11.7-4.8 14.2l1.1 0.3c2.3-5.4 4.2-10.7 4.3-11.3 0.3-0.6 6-6 9.6-9.4l11.6 2.9z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "K",
    d: "m123.8 381.3c4.3-1.4 12.2-4.4 12.2-4.4 0 0-1.5 4.8-1 13.8 0.5 9 0.6 14 0.1 18-0.5 3.9-1.9 9.7 0.9 9.9 2.8 0.2 5.5-2.7 8.4-2.6 3 0.2 5.1-2.3 2.7-3.1-2.5-0.7-5.7-0.6-5.3-5.5 0.5-4.9 2.8-17.8 4.2-24.6 1.3-6.9 2.8-11.8 1.5-14.9-1.3-3-4.6-2.5-7-2.6-2.4-0.1-17.9-0.2-17.9-0.2z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "L",
    d: "m137.9 415.9c0 0-0.4-20-0.3-24.2 0.2-4.1 3.3-18.1 3.3-18.1l-17.3 4.5 0.2 3.2c4.3-1.4 12.2-4.4 12.2-4.4 0 0-1.5 4.8-1 13.8 0.5 9 0.6 14 0.1 18-0.5 3.9-1.9 9.7 0.9 9.9 0.9 0 1.7-0.2 2.6-0.6z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "M",
    d: "m131.6 371.3c0 0-0.6 18.4-3.4 28-2.8 9.6-7.4 19.7-8.7 21.9-1.2 2.2-3.3 5.6-5.7 9.3-2.4 3.7-14.6 17.9-16.1 21.7-1.6 3.8-2.6 8-2.6 10.2 0 0.4 2.7 3.3 2.3 3.3-1.7-0.1-9.4-6.6-8.6-8.3 0.9-2.2 1.7-3 3.6-7 1.9-4 9.2-21.6 12.5-25.9 3.4-4.3 6.5-6.8 7.2-8.1 0.7-1.3 2-24.3 1.7-25.3-0.3-1.1-2.6-2.1-2.8-7.6-0.2-5.4 5.5-13.9 5.5-13.9z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "N",
    d: "m116.5 369.6c0 0-5.7 8.5-5.5 13.9 0.2 5.5 2.5 6.5 2.8 7.6 0.3 1-1 24-1.7 25.3-0.7 1.3-3.8 3.8-7.2 8.1-3.3 4.3-10.6 21.9-12.5 25.9-1.9 4-2.7 4.8-3.6 7-0.4 0.8 1.2 2.7 3.1 4.5 0.1-2.8 0.4-5.8 1-7.7 1.6-4.2 8.3-15.9 11.6-21.4 3.2-5.5 8-14 9.1-15.2 1.2-1.1 3.5-6.8 4.7-17 1.2-9.8-1.4-19.3 1.8-30.6z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "O",
    d: "m134.1 413.5c0 0-1 2-0.3 3.6 0.6 1.6 2.2 3.9 2.7 5 0.4 1 0.6 2 0.6 2l1.8 0.1 1.3-1.2c0 0-1.3-4.3 0.2-4.9 1.5-0.6 5.8 1.1 8.1 0.3 2.4-0.9 5.1-2.4 4.2-4.7-0.9-2.3-4-2.2-5.3-2.1-1.4 0.1-2.7 0.4-2.7 0.4 0 0 0.6 1.7-2.3 2.4-2.8 0.7-8.3-0.9-8.3-0.9z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "P",
    d: "m89.3 454.7c0 0-2.3 1.7-2.6 3.7-0.4 1.9-0.5 5.4-0.8 6.7-0.2 1.3-0.6 3-0.6 3l1.9 0.7 1.5-0.3 0.6-3.4c0 0 0.3 1.4 2.2 2.9 2 1.5 4.2 2.3 5.9 1.6 1.7-0.7 3-3.2 1.3-4.4-1.7-1.2-3-1.9-3-1.9 0 0-0.2 2.1-0.7 0.4-0.5-1.7-1.3-6.3-2.5-7.4-1.2-1.2-3.2-1.6-3.2-1.6z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "Q",
    d: "m91.5 468c2 1.5 4.2 2.3 5.9 1.6 0.4-0.2 0.8-0.5 1.2-0.8-1 0.3-1.9 0.5-2.5 0.1-1.5-0.7-2.8-2-3.1-3.2-0.7-2.5-0.8-4.3-1.8-4.3-0.7 0-1.5 2.5-1.9 3.8 0.1 0.3 0.6 1.5 2.2 2.8z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "R",
    d: "m134.4 363.7l9.8 1.1c0 0-1.3 2-2.7 6.6-1.4 4.6-7.4 13.3-7.3 16.2 0.1 2.8-1.3 10-6.8 14.7-8.4 7.1-26.1 7.5-26.1 7.5 0 0-0.2-26.8 4.7-37.8 2.9-6.6 9.6-11.7 10.3-15.5 0.7-3.8 0.5-15.3 0.5-15.3 0 0 3-12 5-14.4 2-2.4 4.8-2.8 4.8-2.8l2.3 1c0 0-5 5.8-2 7.4 2.9 1.5 11.6-4.7 11.6-4.7l1.1 0.1c0 0-5.9 7.7-2.5 12.5 3.4 4.8 10.3-2.3 10.3-2.3 0 0-0.5 7.8-2.9 10.6-2.3 2.8-5.8 3.9-7.1 7-1.4 3-3 8.1-3 8.1z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "S",
    d: "m140.9 348.5c-0.4 2.9-2.2 5.1-2.2 5.1 1.7-1.8 4.1-2.9 5.8-5 2.4-2.8 2.9-10.6 2.9-10.6 0 0-0.7 3.5-3.5 7.7-1 1.4-2.9 2.4-3 2.8z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "T",
    d: "m150.8 417.4c-2.6 1.4-9.2 0.1-11.3 0.3-2.1 0.2-0.7 6.3-0.7 6.3l0.1 0.2 1.3-1.2c0 0-1.3-4.3 0.2-4.9 1.5-0.6 5.8 1.1 8.1 0.3 0.9-0.3 1.9-0.8 2.7-1.3-0.1 0.1-0.3 0.1-0.4 0.3z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "U",
    d: "m144.2 364.8l-9.8-1.1c0 0-1.8 5.4-1.5 11.1 0.2 4.6 1.3 8.8 1.5 11.7 0.9-3.6 5.8-11 7.1-15.1 1.4-4.6 2.7-6.6 2.7-6.6z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "V",
    d: "m109.1 382.8c-0.3-11.4 7.5-20.5 9-24.5 1.5-4 0.8-13.8 4-22.2l-1.7-6.4c-1.8 4.3-3.6 11.5-3.6 11.5 0 0 0.2 11.5-0.5 15.3-0.7 3.8-7.4 8.9-10.3 15.5-4.9 11-4.7 37.8-4.7 37.8 0 0 4.3-0.1 9.6-1-0.5-5.7-1.5-17.5-1.8-26z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "W",
    d: "m141.1 316.5c0.3 2 1.8 6 0.3 9.9-1.6 3.8-2.4 8.3-2.3 10.7 0 3.2 4.2 7.2 4.2 7.2 0 0-7.6 3-17.1 0.3-10.2-2.8-12.2-8.9-11.4-11.8 0.5-1.5 7-8.4 8.7-17.5 1.3-7 4.2-14 11.2-15.4 7.4-1.5 10.9 2.4 11.9 4 0.9 1.5 2.1 3.9 0.3 6.4-1.7 2.5-6.6-1.7-5.8 6.2z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "X",
    d: "m186.8 289.2c0.3 0.9 0.7 2.3 0.8 3.1 0.2 1.1 0 3.6 0 3.6 0 0 0.6-1.8 0.5-3.4 0-0.9-0.2-1.7-0.4-2.3q-0.4-0.5-0.9-1z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "Y",
    d: "m184.4 288.7c0.3 0.8 0.6 1.7 0.6 2.2 0.2 1.2 0 3.6 0 3.6 0 0 0.6-1.7 0.5-3.4-0.1-1-0.3-1.9-0.5-2.6q-0.3 0-0.6 0.2z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "Z",
    d: "m182.1 293.4c-0.5 1.1-1.7 2.2-2.2 2 0.6 0.4 2.6 0.1 3.1-1.2 0.4-1.3 0.7-3.9 0.7-4.6-0.7 1.1-1.2 2.9-1.6 3.8z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "a0",
    d: "m186.3 291.4c0.1 1.2-0.1 3.6-0.1 3.6 0 0 0.7-1.8 0.6-3.4-0.1-1.2-0.4-2.1-0.6-2.8q-0.4-0.1-0.7-0.2c0.3 0.8 0.7 2.1 0.8 2.8z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "a1",
    d: "m121.8 320.8c-2.5 6.3-6.6 10.8-7 12-0.8 2.9 1.2 9 11.4 11.8 9.5 2.7 17.1-0.3 17.1-0.3-19.5-3.3-22.5-11-21.5-23.5z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "a1",
    d: "m140.1 299.8c3 2.7 3.6 6.7 2.6 11.7 1.4-0.5 3.3 0.2 4.2-1.2 1.8-2.5 0.6-4.9-0.3-6.4-0.7-1.1-2.7-3.4-6.5-4.1z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "a2",
    d: "m280.3 329.3c-9.1 10.4-27.5 9.7-47 8.8-11.1-0.5-25.3-5.9-19.5-11.6 10.9-10.8 25.8-5.1 36.6-3.1 10.9 2 40.3-6 29.9 5.9z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "a3",
    d: "m268.6 323.1c-0.9 1.5-4.5 5.5-5.9 7.1-1.7 1.9-2 4.5 1.6 5.1 3.6 0.5 7.3-1.3 8.7-3.2 1.4-1.8 1.3-4 2.9-4.1 0.3 0 1.3-0.4 1.5-0.6 0.6-0.3 2.2-1.8 2.2-1.8 0 0-0.7-2.9-1-3.5-0.6-1.3-1.8-2.9-1.8-2.9l-6.6 1.8c0 0-1.1 1.4-1.6 2.1z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "a4",
    d: "m264.9 327.7c-1.7 1.8-5 5.6-0.4 5.8 4.5 0.1 7.4-2.8 8.4-4 0.9-1.3 1.4-2.3 2.6-2.8 1.1-0.5 3.7-2.5 3.7-2.5 0 0-0.4-2.3-0.7-2.8-0.4-0.5-0.8-1.6-0.8-1.6l-8.4 1.9c0 0-3 4.6-4.4 6z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "a3",
    d: "m235.3 318.8l0.9 5.2c0 0-2.6 1.5-3.8 1.9-1.1 0.4-3.1-0.4-4.1 0.8-0.9 1.3-4.9 4.5-8.2 5.1-3.6 0.7-6.1-0.4-6.1-1.4-0.1-1.1 0.9-2.7 4.1-4.8 3.2-2.2 6-7.3 6-7.3z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "a5",
    d: "m235.6 322.1c-0.5 0.6-6.5 2-7.4 3.2-1.1 1.4-6.7 4.9-9.5 5.4-2.6 0.4-4.5-0.9-4.3-1.9 0.4-1.4 2.7-2.7 4.8-4.2 2-1.6 4.2-5.2 4.2-5.2l12.2-0.9z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "a6",
    d: "m228.2 238.7c0 0-5.5 10.3-6.9 16-1.5 5.6-6 20.7-5.3 26.5 0.6 4.9 3 9.2 4.1 15.1 0.9 4.7 2.6 19.7 1.6 22.7-0.5 1.6 1.2 2.3 6.5 1.8 4-0.4 7.9 0.8 7.9-0.5 0-1.4-1.2-18.9-2.5-26.1-1.2-7.3-3.8-13.4-3.8-13.4l12.2-25.6c0 0-2.4 12.4-3 22.9-0.6 10.5-2.5 16.2-0.3 20.1 2.1 3.9 17.7 14.5 21.4 18.2 3.7 3.8 4.9 8.4 5.4 8.8 1.2 0.9 4.2-0.1 6.8-0.7 2.9-0.7 6.2-2.9 6.4-3.4 0.2-1-2.3-5.9-5.3-9.8-2.7-3.5-10.2-11.5-13.3-14-2.9-2.2-7.7-5.8-7.7-5.8 0 0 7.3-19 8.1-25.6 0.9-6.5 3.8-15.9 2.8-24.1-1-8.3-6.9-10.7-6.9-10.7 0 0-10.6 8.3-15.4 9.4-4.9 1-12.8-1.8-12.8-1.8z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "a1",
    d: "m229.8 280.8l12.2-25.6-0.7-9.9c0 0-1.2 1-3.5 6.1-2.9 6.3-13.7 25.7-12.9 29.6 0.8 3.8 5.7 10.7 7.5 39.8 2.1 0.1 3.7 0.3 3.7-0.5 0-1.4-1.2-18.9-2.5-26.1-1.2-7.3-3.8-13.4-3.8-13.4z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "a1",
    d: "m274.3 323.8c2.2-0.9 4.3-2.3 4.4-2.7 0.2-1-2.3-5.9-5.3-9.8-2.7-3.5-10.2-11.5-13.3-14-2.9-2.2-7.7-5.8-7.7-5.8 0 0 7.3-19 8.1-25.6 0.9-6.5 3.8-15.9 2.8-24.1-0.5-4.1-2.1-6.7-3.7-8.3l-8.2 5c0 0 1.8 12.8 1.6 22.6-0.3 16.4-8.2 29.4-6 33.3 2.3 3.8 19.8 9.9 27.3 29.4z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "a7",
    d: "m183 261.5c-1.2 2.6-2.8 6.4-3.8 7.4-0.9 1-5 5.1-5.2 6.9-0.2 1.9 1.5 7.6 2.5 8.5 1.1 0.9 2.1 2.1 3 2 0.8-0.2 1.6-0.4 1.6-0.4 0 0 1.6 0 2.5-0.4 0.9-0.4 0.9-1.4 0.3-1.5-0.5-0.1-1.5-0.2-2.2-0.5-0.7-0.4-2.2-3.5-2.2-3.5l0.4-0.6c0 0 0.7 3.1 1.8 3.3 1.1 0.2 0.5-3 0.5-3.5 0.1-0.5 0.9-6.4 1.6-7.3 0.7-1 9.2-12.1 12.3-18.3 3-6.1-13.1 7.9-13.1 7.9z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "a8",
    d: "m179.5 267.4l5.9 3.1 2.1-2.6c0 0 7.4-8.5 10.2-14.9 2.8-6.4 11.3-25.3 11.3-25.3 0 0 5.3 5.2 10.2 7.6 4.9 2.5 7.1 3.5 7.4 4.5 0.3 1-0.2 2.1-0.2 2.1 0 0 9.9 5.4 16.6 3.4 11.9-3.6 16.7-13 16.7-13 0 0-8.5-9.9-12.5-15.1-4.1-5.2-5.7-7.1-13-9-7.2-1.9-25.9-5.8-31.7 1.7-5.7 7.6-5.8 14.5-7.5 20.8-1.7 6.3-2.4 11.2-4.3 13.7-1.9 2.5-8.9 15.6-9.5 17.5-0.6 1.9-0.7 3.5-0.7 3.5z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "a9",
    d: "m217.8 205.3c1.8 2.3 3 4 4.3 4.3 2.1 0.6 5 5 0.2 9.1-4.2 3.4-8.4 2.2-11.4-1.3-3-3.5 6.9-12.1 6.9-12.1z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "m217.1 210.8c1.2 11.2 0.9 12.1-2 12.8-2.9 0.7-6.8-3.4-7-8.4-0.2-4.9 8.5-8.9 9-4.4z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "m255.6 258.9c0 0-0.4 2.9-1.1 4.3-0.6 1.4-3.1 5.1-3.1 5.8-0.1 0.6 0 2.3-0.1 3.3-0.1 1-0.9 3-0.3 3.5 0.6 0.5 1.5-1.7 1.5-1.7 0 0-0.3 1.9-0.4 2.5 0 0.5-0.2 2.7-0.1 3.1 0.1 0.5 0.8 2.6 1.4 2.5 0.7-0.2 0.5-1.9 0.4-2.5 0-0.7 0.9-6 1.1-6.1 0.2 0-0.3 3-0.2 3.7 0 0.6 0.2 3.2 0.5 3.6 0.3 0.5 0.9 1.9 1.6 1.7 0.7-0.2 0.2-1.8 0-2.2-0.2-0.5-0.2-2.4-0.2-3 0.1-0.7 0.6-3.8 0.8-3.8 0.3-0.1-0.3 2.6-0.3 3.2 0.1 0.6 0.3 2.4 0.7 2.9 0.3 0.6 1.8 1.2 2 0.9 0.2-0.3-0.6-1.9-0.7-2 0-0.2 0-1.7 0.1-2.1 0-0.4 0.3-2.7 0.5-2.9 0.2-0.2 0.1 1.4 0.2 1.9 0 0.6 0 1.7 0.2 2.3 0.2 0.5 0.8 1.5 1.3 1.5 0.4-0.1 0-1.9 0-2.7 0.1-0.9 0.4-3.5 0.6-5.4 0.1-1.9 0.1-4.5-0.1-6.2-0.1-1.6-0.5-3.1-0.5-3.7 0.1-0.7 0.4-2.4 0.4-2.4z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "m202.1 196.9c-2.6 2.2-5.2 5.3-2.2 13 3 7.6 6 11.7 8.9 11.1 2.8-0.7 7.6-5.1 8.3-6.5 0.7-1.4 3.6-10.2 0.3-15.8-3.3-5.6-10.8-5.4-15.3-1.8z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "ad",
    d: "m198.1 204.5c0.6 1.8 5.6 2.3 9 0.9 3.4-1.4 5.9 2.7 5.9 2.7l1.6-0.6c0 0 1-4 2.5-3.7 1.6 0.2 1.9 2.3 1.7 3.5-0.2 1.2 1-0.5 1-2 0-1.6-1.3-12.5-10.9-12.5-9.6 0-11.7 8.7-10.8 11.7z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "ae",
    d: "m252.4 240.8c-0.3 11 2.2 23.3 3.6 22 2.4-2.3 4.9-30.4 4.9-30.4 0 0-9.7-10-13.7-15.2q-0.6-0.8-1.2-1.4c-7.3-1.8-13.5-1.6-14.1 3.6-0.5 3.6 2.4 6.8 10.3 10.9 4.9 2.7 8.4 8.1 10.2 10.5z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "af",
    d: "m236.9 212c-4.9 0.6-8.9 9.8 0.5 13.6 9.3 3.8 18.2 10.2 18.2 10.2 0 0 0.3 2.9 0.1 7.4-0.2 4.4-1.6 11.3-1.4 12.5 0.3 1.3 0.6 2.5 0.6 2.5l-0.2 1.9 7 1.1 0.4-2c0 0 0.9-1.9 1.8-5.2 0.9-3.2 3.1-17.9 2.6-21.1-0.6-3.2-7.8-8.8-13.3-12.7-5.6-3.8-8.3-9.3-16.3-8.2z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "a1",
    d: "m201.7 239c-2.3 6.9-2.3 5.7-3.1 7.1-0.8 1.5-5.9 8.3-8.5 13.7-1.6 3.3-4 7.4-5.7 10.1l1 0.6 2.1-2.6c0 0 7.4-8.5 10.2-14.9 2.8-6.4 11.3-25.3 11.3-25.3l-1.9-2.8c0 0-3.2 7.3-5.4 14.1z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "a1",
    d: "m213 208.1l1.6-0.6c0 0 1-4 2.5-3.7 1.6 0.2 1.9 2.3 1.7 3.5-0.2 1.2 1-0.5 1-2 0-1.3-0.9-9-6.6-11.6 2 2.4 2.6 4.6 1.7 9.3-0.3 1.2-1.9 5.1-1.9 5.1z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "ag",
    d: "m179.9 279.4v-2.6c0 0-1.4 1.1-1.2 2.2 0.1 1.1 2.7 4.4 2.7 4.4l-1.9-3.4z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "ah",
    d: "m182.5 285.7c0 0-1.5-0.1-2.1-0.5-0.6-0.4-2.7-3.4-2.7-3.4 0 0 1.9 3.4 2.2 3.6 0.3 0.2 1.2 0.5 1.2 0.5z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "ai",
    d: "m179.1 286.3c0 0-1.7-1.2-1.9-1.8-0.2-0.6-0.9-2.1-0.9-2.1l0.5 2.2 1.7 1.4z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "a3",
    d: "m383.3 135.3c0-0.6 1.6-2.6 3-2.9 1.5-0.4 3.4-0.4 4.3 1.8 0.9 2.3 1.2 4.2 1.2 4.2l-0.4 0.9c0 0 0.6 3.6 1.3 5.2 0.7 1.7 2.7 4.1 2.4 9.6-0.1 3-4.7 5.3-7.1 1.8-2.5-3.4-2.8-9.9-2.8-9.9z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "aj",
    d: "m385.4 132.9c1.5-0.5 3.4 0.2 4.6 5.4 1.1 5.1 2.9 9 3.5 11.5 0.5 2.6 1.7 7.3-3.3 7.1-3.3-0.1-4.6-6-5-11.3-0.4-5.3-3.5-11.4 0.2-12.7z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "a3",
    d: "m420.1 138c0 0 0.2-3.4 2.1-4 1.9-0.6 4.4-0.1 4.9 1.4 0.6 1.4 1.2 5.9 1.5 7.3 0.8 4.2 1.9 9.1-0.1 12.8-1.2 2.2-6.8 3.6-8 0.2-1.2-3.4 0.5-8.6 0.6-11.8 0.1-3.2-0.9-3.9-1-5.9z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "ak",
    d: "m422.7 135c2.9-1.1 4.2 0.2 4.8 4.8 0.7 4.7 2.1 9.5 0.9 14.5-0.6 2.4-6.2 4.9-7.6 0.7-1.6-4.7 1.3-8.4 0.6-13.3-0.6-4.7-0.6-6 1.3-6.7z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "al",
    d: "m364.3 92l29.8-3.2c0 0 3.3 8.6 5 13.4 1.7 4.8 7 13.7 8.8 19 1.8 5.2 4.9 15.3 4.9 15.3 0 0 2 0.1 4.9 0.3 2.9 0.3 6.3-2.7 8.4 0.1 2.1 2.8 2.6 10.5 1 11.7-1.5 1.3-4 0.4-6.5 0.5-3.1 0-6 2.7-9.3 2.8-3.3 0.1-4.5-2.1-9.2-8.2-4.8-6.1-20.2-27.8-20.2-27.8l-4.2 19.3c0 0 5.6-1.2 7-2.1 1.4-1 3.2 0.8 4 5.2 0.9 4.3-0.5 8.2-2.5 8.6-2.1 0.3-4.6-0.8-6.6 0.3-1.9 1.1-7.7 5.4-11.2 4.2-3.5-1.2-3.6-4.1-4.7-9.7-1.2-5.6-3-12.8-2-25.9 1-13 2.6-23.8 2.6-23.8z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "a1",
    d: "m428.1 145.2c0-2.8-0.7-6.5-2-8.3-2.1-2.8-5.5 0.2-8.4-0.1-2.9-0.2-4.9-0.3-4.9-0.3 0 0-3.1-10.1-4.9-15.3-1.8-5.3-7.1-14.2-8.8-19-1.7-4.8-5-13.4-5-13.4l-6.8 0.7c0.5 5.2 1.3 10 2.4 13.3 1.7 4.9 20.8 39.6 21.6 41.3 0.9 1.7-0.1 4.7 4.7 3.5 4.1-0.9 9.1-3 12.1-2.4z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "a1",
    d: "m379.2 107.4c-0.6-2.8-1.1-8.6-1.1-8.6l-3.9-0.2c0 0 0.2 6.9 1.3 9.8 1.2 3 2.2 4.7 2.2 4.7 0 0-3.6 7-3.5 12 0.2 4.9-1.9 17.4-1.7 18.4 0.3 1 5.6-0.4 10.4 0.2 1.7 0.2 3.7 0.4 5.5 0.7 0.6-1.6 0.8-3.8 0.3-6.1-0.8-4.4-2.6-6.2-4-5.2-1.4 0.9-7 2.1-7 2.1l4.2-19.3c0 0-2.1-5.6-2.7-8.5z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "am",
    d: "m421.9 20.2c-0.1-2.4-0.8-5.5-1.4-5.8-0.7-0.4-2.5 0.3-3.2-0.4-0.7-0.7-2.4-3-2.2-3.8 0.3-0.7 4.4-2.4 5.6-2.7 1.2-0.2 4.2 1.9 4.8 4.3 0.6 2.4 1.3 4.9 1.2 7.5 0 2.1-0.6 5.5-0.7 8.5-0.1 3 0.3 16.2-2.3 18.4-2.7 2.3-15.2 8.4-17.6 11-2.3 2.7-3.7 4.5-3.7 4.5l-2.2-15.1c0 0 8-2.1 10.6-2.8 2.6-0.8 6.3-1.9 6.3-1.9 0 0 0-4.2 1.6-9.9 1.6-5.6 3.3-9.8 3.2-11.8z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "an",
    d: "m356 11.2c-0.4 0.6-2.4 8.4-3.9 13.1-1.5 4.7-3.2 9-3.2 9 0 0 5.5 1.8 8.2 3.9 2.6 2.2 8.5 3.4 11.6 4.9 3.1 1.6 4.8 2.9 4.8 2.9l-14.2 6.6c0 0-10.1-8.5-13.3-10-3.2-1.6-7.7-5.6-7.2-8.1 0.5-2.5 11.9-23.5 12.7-24.3 0.7-0.9 4.1-7.3 6.2-8.5 2.1-1.3 5.6 0.5 6.6 1.2 1 0.8 4.1 1 3 2.7-1.1 1.8-4.5 3.8-6.8 4.9-2.4 1.2-4.5 1.7-4.5 1.7z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "ao",
    d: "m377.6 45c-2.8-0.6-5.8-2.2-10.2-3.8-4.4-1.6-9.8-4.4-12-5.6-2.1-1.2-5.9-2.2-5.9-2.2 0 0 5-13.7 5.6-16.6 0.7-2.9 0.7-2.9 0.7-2.9l0.1-1.8-5.5-2.9-0.8 2c0 0-1.6 0.6-2.3 2.2-0.8 1.7-8 17.3-8.9 19-1.6 2.8-0.1 5.8 3.4 7.6 3.4 1.7 14 12.5 15.3 16.5 1.2 3.9 3.8 8.3 4.2 12.6 0.5 4.3 2 13.6 1.4 18.2-0.5 4.5-0.8 6.4 0 7.4 0.9 1 1.3 1 1.3 1l-0.5 2.2c0 0 10.5 1.7 18.9 0.7 8.5-1 13-6.3 13-6.3l-0.7-2.2c0 0 0.6-1 0.5-3-0.1-2-0.3-10.7 2.2-15.3 2.5-4.6 9.5-13.3 12.6-15 3.1-1.7 14.7-7.4 16.1-10.8 1.4-3.4 1.3-17.2 1.3-20.3 0-2.2-0.5-4.5-0.5-4.5v-1h-5l-0.5 1.3c0 0-0.6 0.6-0.9 1.5-1.7 4.8-2.5 7.6-2.8 9.7-0.2 2.5-1 8.5-1 8.5 0 0-4.4 1.4-7.7 2.4-3.4 1.1-5.1 1.6-11.7 2.5-6.6 0.9-13.8 0.1-19.7-1.1z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "a1",
    d: "m427.4 25.7c0-2.2-0.5-4.5-0.5-4.5v-1h-1.7l-0.4 2c0 0-1 6.6-0.8 12.5 0.2 6 0.7 9.6 0.2 10.6-0.5 1.1-20.5 9.4-23.3 10.5-7.4 2.7-14.2 16.4-14.2 25.7 0.1 5.3 0.8 10.9 1.6 15.5 4.7-1.9 7.1-4.7 7.1-4.7l-0.7-2.2c0 0 0.6-1 0.5-3-0.1-2-0.3-10.7 2.2-15.3 2.5-4.6 9.5-13.3 12.6-15 3.1-1.7 14.7-7.4 16.1-10.8 1.4-3.4 1.3-17.2 1.3-20.3z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "ap",
    d: "m358.6 4.8c0-0.9 0.5-2.5 0.8-2.4 0.3 0 3.3 1.5 3.2 1.8-0.1 0.4-0.9 1.4-1.3 1.2-0.5-0.2-1.7-1.4-2.1-1-0.4 0.3-0.6 0.4-0.6 0.4z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "aq",
    d: "m420.6 10.4c0 0-2.9 0.4-2.9 0.7-0.1 0.3 3.6 0.6 3.6 0.6z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "a1",
    d: "m355.9 47.9c0 0-5.9-5.6-9.1-8-2.4-1.9-6.6-2.6-8.8-3.8 0.5 1.5 1.8 2.9 3.8 3.9 3.1 1.6 12.2 10.7 14.7 15.3-0.4-3.5-0.6-7.4-0.6-7.4z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "ar",
    d: "m375 44.5c-2.2 0-6.9 2.7-3.9 5.9 3.1 3.1 14.6 4.1 19.1-0.5 4.5-4.7-6.5-4-6.5-4z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "as",
    d: "m384.6 21.4c-3.2 1.1-5.6 5.5-6.8 8.9-1.2 3.3-1 6.1-1.1 7.3-0.2 1.1-0.9 5.4-1.9 6.4-1 1-3.5 2.9-3.5 4.2 0.1 1.2 2.8 3.7 7.6 3.8 4.7 0.1 10.7-2.1 11.3-3.7 0.6-1.4-2.4-2.7-1.5-5 0.6-1.8 5.7-4.5 6.4-7.2 0.6-2.7 1-7-0.4-10.6-1.1-2.7-5.8-5.6-10.1-4.1z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "at",
    d: "m382.9 22c-0.2 0.1 6.4-1.8 10.2 3.2 1.2 1.7 1.5 4 1 5.5-0.5 1.2-1.7 3.7-1.7 3.7l0.5 0.3c0 0 2.2-0.7 2.1 0.7-0.2 1.4-3.1 4-3.4 4.5-0.4 0.4 3.2-1.4 4.8-5.3 2.2-5.5 1.3-11.2-3.9-13.4-5.6-2.4-9 0.1-9.6 0.8z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    className: "au",
    d: "m380.4 46c-3.2-0.6-3.6-11-3.2-10.1 0.7 2.2 7.8 5.7 10.3 3 0.8-0.8-4.7 7.6-7.1 7.1z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "a2",
    d: "m424.3 168.6c0 5.7-8.9 10.2-19.8 10.2-11 0-19.9-4.5-19.9-10.2 0-5.6 8.9-10.2 19.9-10.2 10.9 0 19.8 4.6 19.8 10.2z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    className: "av",
    d: "m17.4 479.6q-0.3 0-0.5-0.2l-12.5-7.4 60.2-34.7c0.5-0.3 1.1-0.1 1.4 0.3 0.3 0.5 0.1 1.1-0.4 1.4l-57.2 33.1 9.5 5.6c0.4 0.3 0.6 0.9 0.3 1.4-0.2 0.3-0.5 0.5-0.8 0.5z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    className: "aw",
    d: "m78.3 463.7c14.2-7.6 19.6-25.4 12-39.6-7.7-14.2-25.4-19.6-39.6-11.9-14.2 7.6-19.6 25.3-12 39.5 7.7 14.3 25.4 19.6 39.6 12z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    className: "av",
    d: "m480.5 228.8c-0.5 0-1-0.4-1-1v-65.4l-26.4-14.6c-0.5-0.3-0.7-0.9-0.4-1.4 0.3-0.4 0.9-0.6 1.4-0.3l27.4 15.1v66.6c0 0.6-0.4 1-1 1z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    className: "ax",
    d: "m413.7 466.5l31.8-18.6c3.8-2.2 3.8-7.7 0-9.9l-59-29-44 24.9 65.5 32.6c1.7 1.1 3.9 1.1 5.7 0z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    className: "ax",
    d: "m388.2 410.3l-43.2 24.5 63.2 31.6c1.7 1 4 0.9 5.7-0.1l31.2-18.3c3.6-2.1 4-7.5 0.4-9.6z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    className: "ax",
    d: "m389.9 411.6l-42.5 24.1 61.1 30.6c1.6 0.9 3.9 0.7 5.5-0.2l30.7-18c3.5-2 4.1-7.3 0.7-9.3z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    className: "ax",
    d: "m391.6 412.9l-41.7 23.7 58.8 29.5c1.6 0.9 3.9 0.7 5.5-0.2l30.1-17.7c3.3-1.8 4.3-7.1 1-9z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    className: "ax",
    d: "m393.4 414.1l-41.1 23.4 56.7 28.5c1.4 0.8 3.9 0.5 5.3-0.3l29.7-17.3c3-1.8 4.3-7 1.3-8.8z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    className: "ax",
    d: "m395.1 415.4l-40.3 23 54.5 27.5c1.3 0.8 3.8 0.3 5.2-0.5l29.1-16.9c2.9-1.7 4.5-6.8 1.6-8.5z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    className: "ay",
    d: "m396.8 416.7l-39.5 22.5 52.2 26.5c1.3 0.8 3.8 0.3 5.1-0.5l28.6-16.6c2.7-1.6 4.6-6.6 1.9-8.1z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    className: "ay",
    d: "m398.5 418l-38.8 22.1 50.1 25.5c1.2 0.7 3.8 0.1 5-0.6l28-16.3c2.5-1.4 4.8-6.3 2.3-7.8z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    className: "ay",
    d: "m400.2 419.2l-38 21.8 47.9 24.5c1.1 0.6 3.7-0.1 4.8-0.7l27.5-16c2.4-1.3 4.9-6.1 2.6-7.5z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    className: "ay",
    d: "m401.9 420.5l-37.3 21.4 45.7 23.5c1 0.6 3.7-0.2 4.8-0.8l26.9-15.6c2.2-1.3 5.1-6 2.9-7.3z"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    className: "ay",
    d: "m403.6 421.8l-36.5 21 43.5 22.4c0.9 0.6 3.7-0.3 4.6-0.9l26.5-15.2c1.9-1.2 5.1-5.8 3.1-7z"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    className: "ay",
    d: "m405.3 423.1l-35.8 20.6 41.4 21.4c0.8 0.5 3.6-0.5 4.5-1l25.9-14.9c1.8-1 5.3-5.6 3.5-6.7z"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    className: "ay",
    d: "m407 424.4l-35 20.2 39.1 20.4c0.8 0.4 3.6-0.7 4.4-1.1l25.4-14.6c1.6-0.9 5.4-5.4 3.8-6.4z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    className: "ay",
    d: "m408.7 425.6l-34.2 19.9 36.9 19.3c0.7 0.4 3.6-0.7 4.3-1.1l24.8-14.3c1.4-0.8 5.6-5.2 4.1-6.1z"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    className: "ay",
    d: "m410.4 426.9l-33.5 19.5 34.7 18.3c0.6 0.4 3.6-0.9 4.2-1.2l24.3-13.9c1.3-0.8 5.7-5.1 4.5-5.8z"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    className: "ay",
    d: "m412.2 428.2l-32.8 19.1 32.5 17.3c0.5 0.3 3.5-1.1 4.1-1.4l23.7-13.5c1.1-0.7 5.9-4.9 4.8-5.5z"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    className: "az",
    d: "m413.9 429.5l-32.1 18.7 30.4 16.2c0.4 0.3 3.5-1.1 3.9-1.4l23.2-13.2c1-0.5 6-4.7 5.1-5.2z"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    className: "az",
    d: "m415.6 430.7l-31.3 18.4 28.1 15.2c0.4 0.2 3.5-1.3 3.9-1.5l22.7-12.9c0.7-0.4 6.1-4.5 5.4-4.9z"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    className: "az",
    d: "m417.3 432l-30.6 18 26 14.2c0.3 0.1 3.4-1.5 3.7-1.6l22.2-12.6c0.5-0.3 6.2-4.3 5.7-4.6z"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    className: "az",
    d: "m419 433.3l-29.8 17.5 23.8 13.3c0.1 0.1 3.4-1.6 3.6-1.7l21.6-12.3c0.4-0.2 6.4-4.1 6-4.3z"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    className: "az",
    d: "m420.7 434.6l-29 17.1 21.5 12.2c0.1 0.1 3.4-1.7 3.5-1.8l21.1-11.8c0.2-0.1 6.5-4 6.4-4.1z"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    className: "az",
    d: "m413.5 463.8l30.6-17.1-21.7-10.9-28.3 16.8z"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    className: "ax",
    d: "m343.2 293.8l15.6-9.6 15.7-9.6c3.8-2.4 8.6 0.2 8.8 4.6l2.3 41.5 2.2 41.6-21.3 13.6-21.3 13.5-2.4-45.2-2.3-45.2c-0.1-2.1 0.9-4.1 2.7-5.2z"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    className: "ax",
    d: "m359.1 284.7l15.3-9.4c3.6-2.2 8.5 0 8.7 4.2l1.1 20.3 1.1 20.2 1.8 39.8-20.6 13.1-20.9 13.4-1.3-22.1-1.2-22-1.8-43.3c-0.1-2 1-3.9 2.6-4.9z"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    className: "ax",
    d: "m359.3 285.2l15-9.2c3.4-2.1 8.3-0.1 8.5 3.9l1.1 19.7 1.2 19.7 1.2 38.1-19.8 12.6-20.6 13.1-1.2-21.4-1.3-21.5-1.2-41.4c-0.1-1.9 0.9-3.7 2.5-4.7z"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    className: "ax",
    d: "m359.5 285.6l14.7-8.9c3.2-2 8.2-0.3 8.4 3.5l1.1 19.2 1.1 19.2 0.7 36.4-19 12.1-20.3 12.8-1.2-20.8-1.3-20.9-0.7-39.5c-0.1-1.8 1-3.6 2.5-4.5z"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    className: "ax",
    d: "m359.7 286.1l14.4-8.7c3-1.9 8.1-0.4 8.2 3.1l1.2 18.7 1.1 18.7 0.2 34.6-18.3 11.6-19.9 12.7-1.3-20.3-1.3-20.3-0.1-37.6c-0.1-1.7 1-3.4 2.4-4.3z"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    className: "ax",
    d: "m359.9 286.6l14.1-8.5c2.8-1.8 7.9-0.6 8.1 2.8l1.1 18.1 1.2 18.2-0.4 32.9-17.5 11.1-19.6 12.4-1.3-19.7-1.3-19.7 0.4-35.7c0-1.6 1.1-3.2 2.4-4.1z"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    className: "ay",
    d: "m360.2 287.1l13.7-8.3c2.7-1.7 7.8-0.7 7.9 2.4l1.2 17.6 1.1 17.6-0.9 31.2-16.7 10.7-19.2 12.1-1.4-19.1-1.3-19.1 1-33.8c-0.1-1.5 1-3.1 2.3-3.9z"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    className: "ay",
    d: "m360.4 287.5l13.4-8c2.5-1.5 7.6-0.9 7.8 2l1.1 17.1 1.2 17.1-1.4 29.5-16 10.1-18.9 12-1.4-18.6-1.4-18.5 1.6-31.9c0-1.4 1.1-2.9 2.3-3.6z"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    className: "ay",
    d: "m360.6 288l13.1-7.8c2.3-1.4 7.5-1 7.6 1.7l1.2 16.6 1.1 16.5-1.9 27.8-15.2 9.6-18.6 11.7-1.4-18-1.4-17.9 2.2-30c-0.1-1.3 1.1-2.7 2.1-3.4z"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    className: "ay",
    d: "m360.8 288.5l12.8-7.6c2.1-1.3 7.4-1.2 7.5 1.3l1.1 16.1 1.2 16-2.5 26-14.4 9.2-18.2 11.4-1.4-17.4-1.5-17.3 2.7-28.1c0-1.2 1.1-2.6 2.1-3.2z"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    className: "ay",
    d: "m361 289l12.5-7.4c1.9-1.2 7.2-1.3 7.3 1l1.2 15.5 1.2 15.5-3 24.3-13.7 8.6-17.9 11.2-1.4-16.7-1.5-16.8 3.3-26.2c-0.1-1.1 1.1-2.4 2-3z"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    className: "ay",
    d: "m361.3 289.4l12.1-7.1c1.8-1.1 7.1-1.5 7.2 0.6l1.1 15 1.2 15-3.5 22.6-12.9 8.1-17.5 11-1.5-16.2-1.5-16.2 3.8-24.3c0-1 1.2-2.3 2-2.8z"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    className: "ay",
    d: "m361.5 289.9l11.8-6.9c1.6-1 6.9-1.6 7 0.2l1.2 14.5 1.2 14.5-4.1 20.8-12.1 7.7-17.2 10.7-1.5-15.6-1.5-15.6 4.4-22.4c-0.1-0.8 1.1-2.1 1.9-2.6z"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    className: "ay",
    d: "m361.7 290.4l11.5-6.7c1.4-0.8 6.8-1.8 6.9-0.1l1.2 13.9 1.1 14-4.5 19.1-11.4 7.2-16.8 10.4-1.6-15-1.5-15 4.9-20.5c0-0.7 1.2-1.9 1.9-2.3z"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    className: "ay",
    d: "m361.9 290.9l11.2-6.4c1.2-0.8 6.7-2.1 6.7-0.6l1.2 13.4 1.2 13.4-5.1 17.4-10.6 6.7-16.5 10.3-1.6-14.5-1.5-14.4 5.5-18.5c0-0.7 1.2-1.9 1.8-2.2z"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    className: "ay",
    d: "m362.2 291.4l10.8-6.2c1-0.7 6.5-2.2 6.6-1l1.2 12.9 1.2 12.9-5.7 15.7-9.8 6.2-16.2 10-1.6-13.9-1.6-13.8 6.1-16.6c0-0.6 1.2-1.7 1.7-2z"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    className: "az",
    d: "m362.4 291.8l10.4-5.9c0.9-0.6 6.5-2.4 6.5-1.3l1.2 12.4 1.2 12.3-6.1 14-9.1 5.7-15.8 9.7-1.6-13.3-1.7-13.2 6.7-14.7c0-0.5 1.2-1.5 1.6-1.8z"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    className: "az",
    d: "m362.6 292.3l10.1-5.7c0.8-0.5 6.3-2.5 6.4-1.7l1.2 11.9 1.2 11.8-6.7 12.2-8.3 5.2-15.5 9.5-1.6-12.6-1.7-12.7 7.2-12.8c0-0.4 1.3-1.4 1.6-1.6z"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    className: "az",
    d: "m362.8 292.8l9.8-5.5c0.6-0.3 6.2-2.7 6.2-2l1.2 11.3 1.2 11.3-7.1 10.5-7.6 4.7-15.1 9.3-1.7-12.1-1.7-12.1 7.8-10.9c0-0.3 1.3-1.2 1.5-1.4z"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    className: "az",
    d: "m363 293.3l9.5-5.3c0.4-0.2 6.1-2.8 6.1-2.4l1.2 10.8 1.2 10.8-7.7 8.8-6.8 4.2-14.8 9-1.7-11.5-1.7-11.5 8.4-9c-0.1-0.2 1.2-1 1.4-1.1z"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    className: "az",
    d: "m363.3 293.7l9.1-5c0.2-0.1 5.9-3 5.9-2.8l1.2 10.3 1.3 10.3-8.3 7-6 3.7-14.4 8.8-1.8-10.9-1.7-10.9 8.9-7.1c0-0.1 1.3-0.9 1.4-0.9z"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    className: "az",
    d: "m348.9 302.2l14.6-8 14.6-7.9 1.2 9.7 1.2 9.8-14 8.5-14.1 8.6-1.8-10.4z"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    className: "aA",
    d: "m381.9 276.8l65.3 168.9-6-2.2-65.4-168.9z"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    className: "aB",
    d: "m381.9 276.8l65.3 168.9 4.2-2.4-65.3-168.9z"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    className: "aC",
    d: "m386.1 274.4l-4.2 2.4-6.1-2.2 4.3-2.4z"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    className: "aD",
    d: "m374 358.5l1.8 4.6-6-2.2-1.8-4.6z"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    className: "aE",
    d: "m374 358.5l1.8 4.6 32.5-18.2-1.7-4.5z"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    className: "aF",
    d: "m406.6 340.4l-32.6 18.1-6-2.2 32.5-18.1z"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    className: "aG",
    d: "m381.1 376.8l1.8 4.6-6.1-2.2-1.7-4.5z"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    className: "aH",
    d: "m381.1 376.8l1.8 4.6 32.5-18.2-1.8-4.5z"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    className: "aI",
    d: "m413.6 358.7l-32.5 18.1-6-2.1 32.5-18.2z"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    className: "aJ",
    d: "m388.2 395.2l1.8 4.6-6.1-2.2-1.7-4.5z"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    className: "aK",
    d: "m388.2 395.2l1.8 4.6 32.5-18.2-1.8-4.5z"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    className: "aL",
    d: "m420.7 377.1l-32.5 18.1-6-2.1 32.5-18.2z"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    className: "aM",
    d: "m395.3 413.6l1.8 4.5-6.1-2.1-1.8-4.6z"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    className: "aN",
    d: "m395.3 413.6l1.7 4.5 32.6-18.1-1.8-4.6z"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    className: "aO",
    d: "m427.8 395.4l-32.5 18.2-6.1-2.2 32.6-18.2z"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    className: "aP",
    d: "m352.4 303.4l1.7 4.6-6-2.2-1.8-4.5z"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    className: "aQ",
    d: "m352.4 303.4l1.7 4.6 32.5-18.2-1.7-4.5z"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    className: "aR",
    d: "m384.9 285.3l-32.5 18.1-6.1-2.1 32.6-18.2z"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    className: "aS",
    d: "m359.4 321.8l1.8 4.5-6-2.1-1.8-4.6z"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    className: "aT",
    d: "m359.4 321.8l1.8 4.5 32.5-18.1-1.7-4.6z"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    className: "aU",
    d: "m392 303.6l-32.6 18.2-6-2.2 32.5-18.2z"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    className: "aV",
    d: "m366.5 340.2l1.8 4.5-6-2.1-1.8-4.6z"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    className: "aW",
    d: "m366.5 340.2l1.8 4.5 32.5-18.1-1.7-4.6z"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    className: "aX",
    d: "m399.1 322l-32.6 18.2-6-2.2 32.5-18.2z"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    className: "aY",
    d: "m402.3 431.8l1.8 4.6-6-2.2-1.8-4.5z"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    className: "aZ",
    d: "m402.3 431.8l1.8 4.6 32.5-18.2-1.7-4.5z"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    className: "b0",
    d: "m434.9 413.7l-32.6 18.1-6-2.1 32.5-18.2z"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    className: "b1",
    d: "m409.4 450.2l1.8 4.5-6.1-2.1-1.7-4.6z"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    className: "b2",
    d: "m409.4 450.2l1.8 4.5 32.5-18.1-1.8-4.6z"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    className: "b3",
    d: "m441.9 432l-32.5 18.2-6-2.2 32.5-18.2z"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    className: "b4",
    d: "m345.1 297.3l65.3 169-6-2.2-65.4-168.9z"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    className: "b5",
    d: "m345.1 297.3l65.3 169 4.2-2.4-65.3-168.9z"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    className: "b6",
    d: "m349.3 295l-4.2 2.3-6.1-2.1 4.3-2.4z"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    className: "ax",
    d: "m37.6 608.3l-31.7-18.6c-3.8-2.2-3.8-7.7-0.1-9.9l42-25.7 44 24.8-24.2 14.7-24.2 14.7c-1.8 1-4 1-5.8 0z"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    className: "ax",
    d: "m46.8 555.2l21.6 12.2 21.6 12.2-23.7 14.4-23.5 13.7c-1.7 1-3.9 1-5.6 0l-6-3.5-24.9-14.6c-3.6-2.1-3.9-7.5-0.3-9.6z"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    className: "ax",
    d: "m45.7 556.3l21.3 12 21.2 12.1-23.2 14.1-22.8 12.7c-1.6 0.9-3.9 0.8-5.5-0.1l-5.8-3.4-24.2-14.2c-3.4-2-3.9-7.2-0.4-9.2z"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    className: "ax",
    d: "m44.7 557.4l20.9 11.8 20.9 11.9-22.7 13.8-22.2 11.7c-1.6 0.9-3.8 0.8-5.3-0.1l-5.7-3.3-23.5-13.8c-3.2-1.9-3.9-6.9-0.6-8.8z"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    className: "ax",
    d: "m43.7 558.5l20.5 11.6 20.5 11.7-22.2 13.5-21.6 10.8c-1.4 0.8-3.6 0.6-5.1-0.2l-5.4-3.2-22.9-13.4c-3-1.7-3.9-6.7-0.8-8.5z"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    className: "ax",
    d: "m42.7 559.6l20.1 11.5 20.2 11.4-21.8 13.3-20.9 9.8c-1.4 0.8-3.6 0.5-4.9-0.3l-5.3-3.1-22.2-12.9c-2.9-1.7-3.9-6.5-1-8.2z"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    className: "ay",
    d: "m41.7 560.7l19.8 11.3 19.7 11.2-21.3 13-20.2 8.8c-1.3 0.8-3.5 0.4-4.8-0.3l-5.1-3-21.4-12.5c-2.8-1.6-4-6.2-1.3-7.8z"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    className: "ay",
    d: "m40.7 561.8l19.4 11.1 19.4 11.1-20.8 12.6-19.6 7.9c-1.2 0.7-3.5 0.2-4.6-0.5l-5-2.8-20.7-12.1c-2.6-1.5-4-6-1.5-7.4z"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    className: "ay",
    d: "m39.7 562.9l19 10.9 19 10.9-20.3 12.3-19 6.9c-1.1 0.7-3.3 0.2-4.4-0.5l-4.8-2.8-20-11.6c-2.4-1.4-4.1-5.7-1.7-7.1z"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    className: "ay",
    d: "m38.7 564l18.6 10.7 18.6 10.7-19.8 12.1-18.3 5.9c-1 0.6-3.2 0-4.3-0.6l-4.6-2.7-19.3-11.2c-2.2-1.2-4.1-5.4-1.9-6.7z"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    className: "ay",
    d: "m37.6 565.1l18.3 10.5 18.3 10.5-19.4 11.8-17.6 4.9c-0.9 0.6-3.2 0-4.1-0.6l-4.5-2.6-18.6-10.8c-2-1.1-4.1-5.2-2.1-6.3z"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    className: "ay",
    d: "m36.6 566.2l17.9 10.3 17.9 10.4-18.9 11.4-16.9 4c-0.9 0.5-3.1-0.2-4-0.7l-4.3-2.5-17.9-10.3c-1.8-1.1-4.1-5-2.3-6z"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    className: "ay",
    d: "m35.6 567.3l17.5 10.2 17.6 10.1-18.4 11.2-16.3 2.9c-0.8 0.5-3.1-0.3-3.8-0.7l-4.1-2.4-17.3-9.9c-1.6-1-4.1-4.7-2.5-5.7z"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    className: "ay",
    d: "m34.6 568.4l17.2 10 17.1 9.9-17.9 10.9-15.7 2c-0.6 0.4-2.9-0.4-3.6-0.8l-3.9-2.3-16.6-9.5c-1.4-0.8-4.1-4.5-2.7-5.3z"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    className: "ay",
    d: "m33.6 569.5l16.8 9.8 16.7 9.7-17.4 10.6-15 1c-0.6 0.4-2.8-0.5-3.4-0.8l-3.8-2.2-15.8-9.1c-1.3-0.7-4.2-4.2-3-4.9z"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    className: "ay",
    d: "m32.6 570.7l16.4 9.5 16.4 9.5-17 10.3-14.3 0.1c-0.5 0.3-2.8-0.6-3.3-0.9l-3.6-2.1-15.1-8.7c-1.1-0.6-4.3-3.9-3.2-4.6z"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    className: "az",
    d: "m31.6 571.8l16 9.3 16 9.4-16.4 10-13.7-1c-0.5 0.3-2.7-0.7-3.1-0.9l-3.5-2-14.4-8.3c-0.9-0.5-4.3-3.7-3.4-4.2z"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    className: "az",
    d: "m30.6 572.9l15.6 9.1 15.7 9.2-16 9.7-13.1-1.9c-0.3 0.2-2.6-0.9-2.9-1.1l-3.3-1.8-13.7-7.8c-0.7-0.5-4.3-3.5-3.6-3.9z"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    className: "az",
    d: "m29.6 574l15.2 8.9 15.3 9-15.5 9.4-12.4-2.9c-0.2 0.2-2.5-0.9-2.8-1.1l-3.1-1.7-13-7.4c-0.5-0.3-4.3-3.2-3.8-3.5z"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    className: "az",
    d: "m28.5 575.1l14.9 8.8 14.9 8.7-15 9.2-11.7-3.9c-0.2 0.1-2.4-1.1-2.6-1.2l-3-1.6-12.3-7c-0.3-0.2-4.3-3-3.9-3.2z"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    className: "az",
    d: "m27.5 576.2l14.6 8.6 14.5 8.6-14.5 8.8-11.1-4.9c-0.1 0.1-2.4-1.1-2.5-1.2l-2.7-1.5-11.7-6.6c-0.1-0.1-4.3-2.7-4.1-2.8z"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    className: "az",
    d: "m40.8 602.6l-15.3-8.6-15.3-8.5 16.3-8.2 14.2 8.4 14.1 8.4z"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    className: "ax",
    d: "m80.8 500.6l-15.7-9.7-15.7-9.6c-3.7-2.3-8.6 0.2-8.8 4.6l-2.4 21.9-2.4 21.9 21.3 13.5 21.3 13.6 2.6-25.5 2.5-25.6c0.1-2.1-1-4-2.7-5.1z"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    className: "ax",
    d: "m40.8 486.3l-2.4 21.1-2.3 21.1 20.9 13.3 21 13.3 2.6-24.9 2-24.5c0.1-2-0.9-3.9-2.6-5l-15.2-9.3-15.4-9.4c-3.5-2.2-8.4 0.1-8.6 4.3z"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    className: "ax",
    d: "m41 486.6l-2.4 20.3-2.3 20.4 20.6 13 20.7 13 2.7-24.1 1.5-23.6c0.1-1.8-1-3.7-2.6-4.7l-14.7-9-15-9.2c-3.4-2.1-8.3-0.1-8.5 3.9z"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    className: "ax",
    d: "m41.2 487l-2.4 19.5-2.3 19.6 20.3 12.7 20.4 12.8 2.7-23.5 1.1-22.5c0.1-1.8-1.1-3.6-2.6-4.5l-14.2-8.7-14.7-8.9c-3.2-2-8.2-0.3-8.3 3.5z"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    className: "ax",
    d: "m41.3 487.3l-2.3 18.8-2.3 18.8 20 12.4 20 12.5 2.9-22.7 0.6-21.5c0-1.7-1.1-3.5-2.6-4.3l-13.7-8.4-14.4-8.7c-3-1.9-8-0.4-8.2 3.1z"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    className: "ax",
    d: "m41.5 487.7l-2.3 18-2.2 18 19.6 12.2 19.7 12.2 2.9-22.1 0.1-20.4c0.1-1.6-1.1-3.3-2.4-4.2l-13.3-8-14-8.5c-2.9-1.8-7.9-0.6-8.1 2.8z"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    className: "ay",
    d: "m41.7 488l-2.2 17.3-2.3 17.2 19.3 11.9 19.4 11.9 3-21.3-0.4-19.5c0.1-1.4-1.2-3.1-2.4-3.9l-12.8-7.7-13.7-8.3c-2.7-1.6-7.8-0.7-7.9 2.4z"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    className: "ay",
    d: "m41.9 488.4l-2.2 16.4-2.3 16.5 19 11.6 19.1 11.6 3-20.6-0.8-18.4c0.1-1.4-1.2-3-2.4-3.7l-12.2-7.4-13.5-8c-2.4-1.6-7.6-0.9-7.7 2z"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    className: "ay",
    d: "m42.1 488.7l-2.2 15.7-2.2 15.7 18.6 11.3 18.7 11.4 3.2-19.9-1.3-17.4c0-1.3-1.3-2.9-2.4-3.6l-11.7-7-13.1-7.8c-2.3-1.5-7.5-1.1-7.6 1.6z"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    className: "ay",
    d: "m42.2 489.1l-2.1 14.9-2.2 14.9 18.3 11.1 18.4 11 3.2-19.2-1.8-16.3c0.1-1.2-1.3-2.8-2.3-3.4l-11.2-6.7-12.8-7.6c-2.1-1.3-7.4-1.2-7.5 1.3z"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    className: "ay",
    d: "m42.4 489.4l-2.1 14.2-2.2 14.1 18 10.8 18.1 10.8 3.3-18.5-2.3-15.4c0.1-1-1.3-2.5-2.3-3.1l-10.7-6.4-12.5-7.4c-1.9-1.2-7.2-1.4-7.3 0.9z"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    className: "ay",
    d: "m42.6 489.8l-2.1 13.3-2.2 13.4 17.7 10.5 17.7 10.5 3.4-17.8-2.7-14.3c0-1-1.4-2.4-2.2-2.9l-10.3-6.1-12.1-7.2c-1.8-1.1-7.1-1.5-7.2 0.6z"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    className: "ay",
    d: "m42.8 490.2l-2.1 12.5-2.1 12.6 17.3 10.2 17.4 10.3 3.5-17.1-3.2-13.3c0-0.9-1.5-2.3-2.2-2.8l-9.8-5.8-11.8-6.8c-1.6-1-6.9-1.7-7 0.2z"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    className: "ay",
    d: "m43 490.5l-2.1 11.8-2.1 11.8 17 10 17.1 9.9 3.5-16.4-3.6-12.2c0-0.8-1.5-2.2-2.2-2.6l-9.3-5.5-11.4-6.6c-1.5-0.9-6.9-1.9-6.9-0.2z"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    className: "ay",
    d: "m43.1 490.9l-2 11-2.1 11 16.7 9.7 16.8 9.7 3.6-15.7-4.2-11.3c0.1-0.6-1.5-2-2.1-2.3l-8.8-5.2-11.1-6.4c-1.2-0.8-6.7-2-6.8-0.5z"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    className: "ay",
    d: "m43.3 491.2l-2 10.3-2.1 10.2 16.4 9.4 16.4 9.4 3.7-15-4.6-10.2c0-0.6-1.6-1.8-2.1-2.2l-8.3-4.8-10.8-6.2c-1-0.6-6.5-2.1-6.6-0.9z"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    className: "az",
    d: "m43.5 491.6l-2 9.4-2 9.5 16 9.1 16.1 9.1 3.7-14.2-5-9.2c0-0.5-1.6-1.7-2.1-2l-7.8-4.5-10.4-5.9c-0.9-0.6-6.5-2.4-6.5-1.3z"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    className: "az",
    d: "m43.7 491.9l-2 8.7-2 8.7 15.7 8.9 15.8 8.8 3.8-13.6-5.5-8.1c0-0.4-1.7-1.6-2-1.8l-7.3-4.2-10.2-5.7c-0.7-0.5-6.3-2.5-6.3-1.7z"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    className: "az",
    d: "m43.9 492.3l-2 7.9-2 7.9 15.4 8.6 15.5 8.5 3.8-12.8-6-7.2c0-0.2-1.7-1.4-1.9-1.5l-6.8-3.9-9.9-5.5c-0.5-0.3-6.1-2.7-6.1-2z"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    className: "az",
    d: "m44 492.6l-1.9 7.2-1.9 7.1 15 8.3 15.1 8.3 4-12.2-6.5-6.1c0-0.2-1.7-1.3-1.9-1.4l-6.3-3.5-9.5-5.3c-0.4-0.2-6.1-2.8-6.1-2.4z"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    className: "az",
    d: "m44.2 493l-1.9 6.4-1.9 6.3 14.7 8 14.8 8 4-11.4-6.9-5.1c0-0.1-1.8-1.1-1.9-1.2l-5.8-3.2-9.2-5.1c-0.2-0.1-5.9-2.9-5.9-2.7z"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    className: "az",
    d: "m73.6 509.2l-14.6-7.9-14.6-8-3.8 11.2 14.4 7.7 14.5 7.8z"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    className: "b7",
    d: "m41.9 487.3l-37.7 100.2 6-2.2 37.8-100.2z"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    className: "b8",
    d: "m42 487.3l-37.8 100.2-4.3-2.4 37.8-100.2z"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    className: "b9",
    d: "m37.7 484.9l4.3 2.4 6-2.2-4.3-2.4z"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    className: "ba",
    d: "m70.2 518.6l-1.7 4.6 6-2.2 1.8-4.6z"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    className: "bb",
    d: "m70.3 518.6l-1.8 4.6-32.5-18.2 1.7-4.5z"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    className: "bc",
    d: "m37.7 500.5l32.6 18.1 6-2.2-32.5-18.1z"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    className: "bd",
    d: "m63.1 537l-1.7 4.6 6-2.2 1.8-4.6z"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    className: "be",
    d: "m63.2 537l-1.8 4.6-32.5-18.2 1.7-4.5z"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    className: "bf",
    d: "m30.6 518.9l32.6 18.1 6-2.2-32.5-18.1z"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    className: "bg",
    d: "m56.1 555.3l-1.8 4.6 6.1-2.2 1.7-4.5z"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    className: "bh",
    d: "m56.1 555.3l-1.8 4.6-32.5-18.2 1.8-4.5z"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    className: "bi",
    d: "m23.6 537.2l32.5 18.1 6-2.1-32.5-18.2z"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    className: "bj",
    d: "m49 573.6l-1.7 4.6 6-2.2 1.8-4.6z"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    className: "bk",
    d: "m49 573.6l-1.7 4.6-32.5-18.2 1.7-4.5z"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    className: "bl",
    d: "m16.5 555.5l32.5 18.1 6.1-2.2-32.6-18.1z"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    className: "bm",
    d: "m42 591.9l-1.8 4.6 6-2.2 1.8-4.5z"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    className: "bn",
    d: "m42 591.9l-1.8 4.6-32.5-18.2 1.7-4.5z"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    className: "bo",
    d: "m9.4 573.8l32.6 18.1 6-2.1-32.5-18.2z"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    className: "bp",
    d: "m78.7 507.8l-37.7 100.3 6-2.2 37.8-100.2z"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    className: "bq",
    d: "m78.7 507.9l-37.7 100.2-4.3-2.5 37.8-100.1z"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    className: "br",
    d: "m74.5 505.5l4.2 2.4 6.1-2.2-4.3-2.4z"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    className: "bs",
    d: "m390.1 306.7c0.2 2.9-2.4 5.4-5.8 5.6-3.4 0.2-6.3-1.9-6.5-4.7-0.2-2.8 2.4-5.3 5.8-5.5 3.4-0.3 6.3 1.8 6.5 4.6z"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    className: "bt",
    d: "m382.3 350.2c0 0-1.3-1.3-1.8-1.6-0.5-0.2-0.8-0.4-1.4-0.2-0.6 0.3 0.1 1.3 0.1 1.3 0 0-0.5-1.1-1-0.9-0.5 0.2-0.5 0.5-0.5 0.6 0 0.1 0.2 0.7 0.2 0.7 0 0-0.7-0.6-1.2-0.4-0.5 0.2-0.4 0.9-0.4 0.9l0.2 0.3c0 0-0.6-0.5-1.1 0-0.4 0.5 0.3 1.9 0.6 2.6 0.4 0.6 1.8 3 3 4.2 1.2 1.2 2.9 2.7 2.9 2.7 0 0 3.8-4 3.6-5.3-0.1-1.4 0-2.3 0.4-3.1 0.2-0.4 1.5-2.1 1.9-2.6 0.7-0.7 0.4-1.3-1-0.9-1.4 0.4-2.2 1.9-2.7 2.4-0.5 0.5-1.4-0.3-1.8-0.7z"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    className: "bu",
    d: "m377.1 351.9c0 0-0.1-0.3-0.4-0.8-0.1-0.3-0.3-0.7-0.3-1.1-0.1 0.3-0.1 0.6-0.1 0.6l0.2 0.3c0.4 0.4 0.6 1 0.6 1z"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    className: "bv",
    d: "m378.5 351.1c0 0-0.2-0.5-0.6-1 0.1 0.1 0.2 0.3 0.2 0.3 0 0-0.4-0.4-0.9-0.6 0.6 0.3 1.3 1.3 1.3 1.3z"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    className: "bw",
    d: "m376.7 353.4c-0.3-0.2-0.8-1-1.2-1.7q0 0 0 0 0.1 0.3 0.1 0.6c0.2 0.5 0.3 0.9 0.4 1.2 0.4 0.6 1.8 3 3 4.2 0.5 0.5 1.1 1 1.6 1.5q0 0 0.1-0.1c-0.2-0.5-0.3-0.9-0.4-1.1-0.5-0.8-3.1-4.2-3.6-4.6z"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    className: "bx",
    d: "m376.3 350.7z"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    className: "by",
    d: "m379.7 350.3c0 0-0.2-0.4-0.6-1.2-0.1-0.2-0.1-0.3-0.2-0.4-0.1 0.2 0.1 0.5 0.2 0.7-0.2-0.2 0.6 0.9 0.6 0.9z"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    className: "bz",
    d: "m393.7 308.1c-1.2-0.8-7.8 5.3-4.8 7.1 3 1.7 7.4-5.3 4.8-7.1z"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    className: "bA",
    d: "m415.4 326.8c-2-3.5-4.1-5.2-8.7-8.2-4.6-3.1-13.9-8.3-14.9-9.9-1-1.7-2.8-4.4-3.8-5.4-0.5-0.5-1.8-1.3-3-1.9-0.9-0.4-1.8-0.6-2.3-0.6-1.2 0.1 0.1 0.9 1 1.4 0.6 0.4 1.8 1.2 1.8 1.2 0 0-0.8-0.5-1.6-1-1.1-0.7-2-0.9-2.9-1-0.8-0.1-2.4 0.4-0.8 1 0.7 0.2 1.5 0.6 2.4 1.2 1.9 1.1 1.6 1.2 1.6 1.2 0 0-0.9-0.6-2.2-1.4-0.7-0.4-1.7-0.6-3.1-0.9-0.9-0.3-2.5 0.7-0.7 1.3 1.6 0.5 1.7 0.5 2.5 1 0.8 0.5 1.7 1.2 1.7 1.2 0 0-0.5-0.3-1.5-0.9-1.1-0.7-1.6-0.5-2.9-0.9-1.4-0.4-2.6 0.5-0.8 1.4 1.8 0.9 2.1 1 3.1 1.5 0.9 0.6 2.1 1.2 2 1.9 0 0.6-0.5 0.1-1.7-0.3-1.2-0.4-2.8 0.5-2.9 1-0.1 0.4 1.1 0.6 2.2 0.8 1.1 0.2 2.6 1.6 4.3 1.9 1.6 0.3 2.7 0.4 3.2 0.6 0.5 0.2 4.9 3 9.6 6.9 4.8 3.9 10 7.2 10.6 7.5z"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    className: "bB",
    d: "m393.1 309.4c0 0-0.4 1.7-1.5 3-1.1 1.3-2.5 1.8-2.5 1.8l3.9 3.3 3.6-6.1z"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    className: "bC",
    d: "m393.7 308.1c0.2 2.2-1.9 6.6-5.2 6.7-0.9 0 5 4.7 6.7 6.6 2.4 2.9 8.9 10.7 11.3 12.9 2.4 2.2 19.4-1.6 18.9-6.1-0.6-4.5-3.6-4.6-8-5.1-4.4-0.4-6.4 1.4-9.6-1.6-3.2-3.1-14.2-14-14.1-13.4z"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    className: "a3",
    d: "m422.6 423.9c0 0 2 3.1 0.8 4.2-1.2 1.1-3.3 2.1-5.3 1.7-2-0.3-2.9-0.9-4.8-0.4-1.8 0.5-10.1-1.3-11.9-2.7-1.9-1.4-1-3.8 2.6-4.4 3.5-0.7 8.6-1.5 9.6-1.4 1 0.1 9 3 9 3z"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    className: "bD",
    d: "m421.7 426.8c-3.2 1.2-4.5 0.6-7.7 0.7-3.2 0.2-12.6-1.1-13-3.1-0.3-2 1.8-2.1 3.5-2.3 1.7-0.3 7.1-1.3 7.5-1.4 0.4-0.1 10.1 1.6 10.1 1.6 0 0 1.3 2.7 0.9 3.3-0.5 0.5-0.5 0.9-1.3 1.2z"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    className: "bE",
    d: "m426.1 389.9l-12.9 4.4c0 0 4.6 9.8 5.8 13.8 1.2 4 4.8 16 2.9 17.2-1.9 1.2-10.4-0.4-11.4-1.4-1-1-1.7-3-1.5-4.1 0.1-1.1-1.6-8.4-4.6-13-3.1-4.6-9.3-14-6.8-20.2 2.6-6.2 20.4-14.3 20.4-14.3z"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    className: "a1",
    d: "m426.1 389.9l-12.9 4.4c0 0 4.6 9.8 5.8 13.8 1.2 4 4.8 16 2.9 17.2-0.7 0.5-2.4 0.5-4.3 0.3 0.2-4.3 0.2-11.3-1.5-15.4-2.6-6.1-10-16.3-10-16.3l16.8-10.9z"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    className: "a3",
    d: "m447.2 435.6c0 0 1.2 2.6 0.9 3.8-0.3 1.3-2.6 2.7-4.8 2.2-2.2-0.6-3.5-2.5-4.4-2.9-0.9-0.4-5.3 0-9-2-3.8-2.1-4-5.2-0.8-5.9 3.2-0.7 9.3-0.4 11.7 0.5 2.3 0.9 6.4 4.3 6.4 4.3z"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    className: "bF",
    d: "m446.2 438.9c-2.2 0.9-5.5-0.5-7.1-1.3-1.6-0.9-3.8 0.2-7.5-1.6-3.6-1.8-5-3.3-3.7-4.4 1.2-1.1 6.4-1.9 10.9-0.6 4.4 1.3 7.4 2.4 7.4 2.4 0 0 1.6 2.7 1.3 3.5-0.4 0.8 0 1.4-1.3 2z"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    className: "bG",
    d: "m432.1 370.2c0 0 3.2 7 4 16.6 0.8 9.5 6.4 27.8 8.2 34.3 1.8 6.6 5.8 14.2 2.8 16.6-1.8 1.3-5.3 1.5-8.7-1.1-3.3-2.5-4.5-5.4-4.3-6 0.2-0.7 0.2-3.3-2-8.6-2.2-5.2-7.1-18.1-7.8-22.4-0.7-4.4-8.1-25.1-8.1-25.1z"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    className: "a1",
    d: "m424.3 399.6c0.7 4.3 5.6 17.2 7.8 22.4 2.2 5.3 2.2 7.9 2 8.6-0.2 0.6 1 3.5 4.3 6 1.3 1 2.7 1.6 3.9 1.9-1.6-2-4.3-6.1-5.8-13.6-2.3-11.3-7.6-25.1-9.6-32.9-1.1-4.6-1.8-13.4-3-19l-7.7 1.5c0 0 7.4 20.7 8.1 25.1z"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    className: "bH",
    d: "m398.9 303.9c-2 1.5-3.9 3.7-2.9 9.1 0.9 5.5 1.3 8.1 2.6 8.7 1.2 0.5 1.9-0.4 2.4 1.1 0.5 1.5 0.5 4.1 0.5 4.1l11.4-5c0 0-1.2-1.7-0.8-3.8 0.4-2.2 3.1-6.6-0.6-11.7-3.7-5.2-10.3-4.2-12.6-2.5z"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    className: "bI",
    d: "m395.2 309.4c0.1 1.1 1.1 2.6 2.6 2.5 1.5-0.2 2.5 1.4 2.3 2.3-0.1 0.9 0.1 1 0.1 1 0 0 1-0.6 1.7 0.2 0.6 0.7 0.3 2.7 0.1 3.5-0.1 0.8 2.7 2.5 4.8 2.3 2-0.3 4.7-1 5.4-2.2 0.7-1.2 3.2-5.3 1-10.6-2.2-5.4-8-7.7-12.5-5.9-4.6 1.8-5.8 5.4-5.5 6.9z"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    className: "bJ",
    d: "m400.2 330.3c0 0 0.4-4.7 3-5.8 2.5-1 4.9-1.2 6.6-2.3 1.6-1.2 2.3-2.9 2.3-2.9 0 0 2.2 0.2 1 2.3-1.2 2.2-12.9 8.7-12.9 8.7z"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    className: "bK",
    d: "m409.3 324.2c2.3-1.3 4.5-3.3 4.5-3.3 0 0 3.8-0.8 6-0.9 2.3-0.1 6 1.3 6.6 5.5 0.5 4.1 0.6 9.5 0.4 15.5-0.3 6 0.5 10.1 2.7 15.6 2.1 5.6 8.1 17.4 8.1 18.9-0.1 1.4-2.2 6.8-8.9 10.7-6.7 3.8-18.5 6.7-24.3 2.1-5.3-4.1-1.6-15.2-4-29.9-1.5-9.3-6.3-16.7-3.3-22.3 3-5.5 6.8-9.3 9.2-10.4 2.4-1.1 3-1.5 3-1.5z"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    className: "a1",
    d: "m399.9 330.7c0.8-1.8 2.7-4.3 4.8-5 2.1-0.6 6-2.3 7.2-3.5 1.3-1.5 1.3-2.5 1.3-2.5l3.5 0.6c0 0 1 3.7-3.3 6-4.2 2.2-9.2 3.1-12.1 5.6-2.7 2.3-4.3 4.5-4.3 4.5z"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    className: "bL",
    d: "m399.9 330.7c0.8-1.8 2.7-4.3 4.8-5 2.1-0.6 6-2.3 7.2-3.5 1.3-1.5 1.3-2.5 1.3-2.5l3.5 0.6c0 0 0.5 3.1-3.7 5.3-4.2 2.2-10 3.7-12.4 6.4-2.5 2.7-3.6 4.4-3.6 4.4z"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    className: "bM",
    d: "m416.3 320.2c0.1 0.7 0 3.3-3.7 5.2-4.2 2.2-9.9 3.7-12.4 6.4q-1.4 1.5-2.2 2.6l-1 2c0 0 1.1-1.7 3.6-4.4 2.4-2.7 8.2-4.2 12.4-6.4 4.2-2.2 3.7-5.3 3.7-5.3z"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    className: "a1",
    d: "m406.5 337.8c-4-4-7.7 0.5-10.3 4.2 0.7 3.1 3.3 10.7 4.2 16.4 2.4 14.7-1.3 25.8 4 29.9 2.8 2.2 7 2.7 11.4 2.2-0.8-2.1-1.6-4.6-2.3-7.4-1.9-7.9-0.3-12.8-1.4-23.7-1-10.9-0.5-16.4-5.6-21.6z"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    className: "a1",
    d: "m413.4 308.8c-0.9 1-2.4 2.3-5.2 3.4-2.9 1.1-6 1.2-8.2 1.1 0.1 0.3 0.2 0.6 0.1 0.9-0.1 0.9 0.1 1 0.1 1 0 0 1-0.6 1.7 0.2 0.6 0.7 0.3 2.7 0.1 3.5-0.1 0.8 2.7 2.5 4.8 2.3 2-0.3 4.7-1 5.4-2.2 0.6-1.2 3.1-5.1 1.2-10.2z"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    className: "bN",
    d: "m403.1 334.5c4.1 0.5 7.4 4.1 5.8 9.4-1.5 5.2-7.9 18.6-10.8 21.4-3 2.8-6.5 3.6-10.3 1.5-3.8-2-7.8-3.6-8.1-6.7-0.3-3.2 3.4-6.2 5.3-6.3 1.9-0.1 5.3 1.9 6.2 1.2 0.9-0.7 3.5-10.4 4.5-13.6 0.9-3.2 2.5-7.6 7.4-6.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeam);
export default __webpack_public_path__ + "static/media/team.cb64265346ff2ef46d9ae330e2adeef8.svg";
export { ForwardRef as ReactComponent };